{
  "about.blocks": "Instancias bajo moderación",
  "about.contact": "Contacto:",
  "about.default_locale": "Predeterminado",
  "about.disclaimer": "Mastodon es software libre y de código abierto, y una marca comercial de Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "No se ha proporcionado una explicación",
  "about.domain_blocks.preamble": "En general, Mastodon te permite ver contenido de cualqueir servidor e interactuar con cualquier usuario del fediverso. No obstante, estas son las excepciones hechas en esta instancia en particular.",
  "about.domain_blocks.silenced.explanation": "No podrás ver contenido de esta instancia ni los perfiles de sus usuarios, a menos que los busques explícitamente u optes por seguirlos.",
  "about.domain_blocks.silenced.title": "Limitado",
  "about.domain_blocks.suspended.explanation": "Ningún dato proveniente de esta instancia será procesado, almacenado o intercambiado, lo que hace imposible la comunicación con sus usuarios.",
  "about.domain_blocks.suspended.title": "Suspendido",
  "about.language_label": "Idioma",
  "about.not_available": "La información no ha sido proporcionada por la instancia.",
  "about.powered_by": "{mastodon}, red social descentralizada",
  "about.rules": "Código de conducta",
  "account.account_note_header": "Nota personal",
  "account.activity": "Actividad",
  "account.add_note": "Añadir una nota personal",
  "account.add_or_remove_from_list": "Añadir o quitar de las listas",
  "account.badges.admin": "Administrador",
  "account.badges.blocked": "Bloqueada",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Dominio bloqueado",
  "account.badges.group": "Grupo",
  "account.badges.muted": "Silenciada",
  "account.badges.muted_until": "Silenciada hasta {until}",
  "account.block": "Bloquear a @{name}",
  "account.block_domain": "Ocultar todo de {domain}",
  "account.block_short": "Bloquear",
  "account.blocked": "Bloqueado",
  "account.cancel_follow_request": "Cancelar solicitud de seguimiento",
  "account.copy": "Copiar enlace al perfil",
  "account.direct": "Mensaje directo @{name}",
  "account.disable_notifications": "Dejar de notificarme cuando @{name} publique",
  "account.edit_note": "Editar nota personal",
  "account.edit_profile": "Editar perfil",
  "account.edit_profile_short": "Editar",
  "account.enable_notifications": "Notificarme cuando @{name} publique",
  "account.endorse": "Mostrar en el perfil",
  "account.familiar_followers_many": "Seguido por {name1}, {name2} y {othersCount, plural, one {una persona más que conoces} other {# personas más que conoces}}",
  "account.familiar_followers_one": "Seguido por {name1}",
  "account.familiar_followers_two": "Seguido por {name1} y {name2}",
  "account.featured": "Destacado",
  "account.featured.accounts": "Perfiles",
  "account.featured.collections": "Colecciones",
  "account.featured.new_collection": "Nueva colección",
  "account.field_overflow": "Mostrar contenido completo",
  "account.filters.all": "Toda la actividad",
  "account.filters.boosts_toggle": "Mostrar Retoots",
  "account.filters.posts_boosts": "Publicaciones y Retoots",
  "account.filters.posts_only": "Publicaciones",
  "account.filters.posts_replies": "Publicaciones y respuestas",
  "account.filters.replies_toggle": "Mostrar respuestas",
  "account.follow": "Seguir",
  "account.follow_back": "Seguir también",
  "account.follow_back_short": "Seguir también",
  "account.follow_request": "Solicitud de seguimiento",
  "account.follow_request_cancel": "Cancelar solicitud",
  "account.follow_request_cancel_short": "Cancelar",
  "account.follow_request_short": "Solicitar",
  "account.followers": "Seguidores",
  "account.followers.empty": "Nadie sigue a este usuario aún.",
  "account.followers_counter": "{count, plural, one {{counter} Seguidor} other {{counter} Seguidores}}",
  "account.followers_you_know_counter": "{counter} que conoces",
  "account.following": "Siguiendo",
  "account.following_counter": "{count, plural, one {{counter} Siguiendo} other {{counter} Siguiendo}}",
  "account.follows.empty": "Este usuario todavía no sigue a nadie.",
  "account.follows_you": "Te sigue",
  "account.go_to_profile": "Ir al perfil",
  "account.hame.invalid_handle": "Alias no disponible",
  "account.hide_reblogs": "Ocultar retoots de @{name}",
  "account.in_memoriam": "En memoria.",
  "account.join_modal.day": "Día",
  "account.join_modal.me": "Te uniste a {server} el",
  "account.join_modal.me_anniversary": "¡Feliz Fediversario! Te uniste a {server} el",
  "account.join_modal.me_today": "¡Es tu primer día en {server}!",
  "account.join_modal.other": "{name} se unió a {server} el",
  "account.join_modal.other_today": "¡Es el primer día de {name} en {server}!",
  "account.join_modal.share.celebrate": "Compartir una publicación para celebrarlo",
  "account.join_modal.share.intro": "Compartir una publicación de presentación",
  "account.join_modal.share.welcome": "Compartir una publicación de bienvenida",
  "account.join_modal.years": "{number, plural, one {año} other {# años}}",
  "account.joined_short": "Unido el",
  "account.languages": "Cambiar la selección de idiomas",
  "account.last_active": "Última actividad",
  "account.link_verified_on": "La propiedad de este enlace se verificó el {date}",
  "account.locked_info": "Esta es una cuenta privada. El propietario autoriza manualmente las solicitudes de seguimiento que recibe.",
  "account.media": "Multimedia",
  "account.mention": "Mencionar a @{name}",
  "account.menu.add_to_collection": "Añadir a colección…",
  "account.menu.add_to_list": "Añadir a lista…",
  "account.menu.block": "Bloquear cuenta",
  "account.menu.block_domain": "Bloquear {domain}",
  "account.menu.copied": "Enlace a la cuenta copiado al portapapeles",
  "account.menu.copy": "Copiar enlace",
  "account.menu.direct": "Mencionar en privado",
  "account.menu.hide_reblogs": "Ocultar Retoots en la línea de tiempo",
  "account.menu.mention": "Mencionar",
  "account.menu.mute": "Silenciar cuenta",
  "account.menu.note.description": "Visible solo para ti",
  "account.menu.open_original_page": "Ver en {domain}",
  "account.menu.open_original_page_no_domain": "Ver en el servidor original",
  "account.menu.remove_follower": "Eliminar seguidor",
  "account.menu.report": "Reportar cuenta",
  "account.menu.share": "Compartir…",
  "account.menu.show_reblogs": "Mostrar Retoots en la línea de tiempo",
  "account.menu.unblock": "Desbloquear cuenta",
  "account.menu.unblock_domain": "Desbloquear {domain}",
  "account.menu.unmute": "Dejar de silenciar cuenta",
  "account.moved_to": "{name} se ha mudado a:",
  "account.mute": "Silenciar a @{name}",
  "account.mute_notifications_short": "Silenciar notificaciones",
  "account.mute_short": "Silenciar",
  "account.muted": "Silenciada",
  "account.mutual": "Se siguen mutuamente",
  "account.name.copy": "Copiar alias",
  "account.name.help.domain": "{domain} es el servidor que aloja el perfil y las publicaciones de este usuario.",
  "account.name.help.domain_self": "{domain} es el servidor que aloja tu perfil y tus publicaciones.",
  "account.name.help.footer": "Al igual que puedes enviar correos a personas que usan distintos proveedores, puedes interactuar con personas de otros servidores de Mastodon y con quienes usan otras aplicaciones del Fediverso.",
  "account.name.help.header": "Un alias funciona como una dirección de correo electrónico",
  "account.name.help.invalid_explanation": "Esto puede ocurrir cuando un usuario cambia su nombre de usuario y, por lo general, es temporal. Si el problema persiste, puede deberse a que su servidor no está disponible o a una configuración incorrecta en ese servidor.",
  "account.name.help.invalid_header": "El alias de este usuario se está actualizando",
  "account.name.help.username": "{username} es el nombre de usuario de esta cuenta en su servidor. Alguien en otro servidor puede tener el mismo nombre de usuario.",
  "account.name.help.username_self": "{username} es tu nombre de usuario en este servidor. Alguien en otro servidor puede tener el mismo nombre de usuario.",
  "account.name_info": "¿Qué significa esto?",
  "account.no_bio": "Sin descripción.",
  "account.node_modal.callout": "Las notas personales solo son visibles para ti.",
  "account.node_modal.edit_title": "Editar nota personal",
  "account.node_modal.error_unknown": "No se pudo guardar la nota",
  "account.node_modal.field_label": "Nota personal",
  "account.node_modal.save": "Guardar",
  "account.node_modal.title": "Añadir una nota personal",
  "account.note.edit_button": "Editar",
  "account.note.title": "Nota personal (visible solo para ti)",
  "account.open_original_page": "Abrir página original",
  "account.pending": "Pendiente",
  "account.posts": "Toots",
  "account.remove_from_followers": "Quitar a {name} de tus seguidores",
  "account.report": "Reportar a @{name}",
  "account.requested_follow": "{name} te ha enviado una solicitud de seguimiento",
  "account.share": "Compartir el perfil de @{name}",
  "account.show_reblogs": "Mostrar retoots de @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} Toot} other {{counter} Toots}}",
  "account.timeline.pinned": "Fijada",
  "account.timeline.pinned.view_all": "Ver todas las publicaciones fijadas",
  "account.unblock": "Desbloquear a @{name}",
  "account.unblock_domain": "Mostrar a {domain}",
  "account.unblock_domain_short": "Desbloquear",
  "account.unblock_short": "Desbloquear",
  "account.unendorse": "No mostrar en el perfil",
  "account.unfollow": "Dejar de seguir",
  "account.unmute": "Dejar de silenciar a @{name}",
  "account.unmute_notifications_short": "Dejar de silenciar notificaciones",
  "account.unmute_short": "Dejar de silenciar",
  "account_edit.advanced_settings.bot_hint": "Indica a los demás que la cuenta realiza principalmente acciones automatizadas y que podría no ser supervisada.",
  "account_edit.advanced_settings.bot_label": "Cuenta automatizada",
  "account_edit.advanced_settings.title": "Ajustes avanzados",
  "account_edit.bio.add_label": "Añadir biografía",
  "account_edit.bio.edit_label": "Editar biografía",
  "account_edit.bio.placeholder": "Añade una breve introducción para ayudar a los demás a identificarte.",
  "account_edit.bio.title": "Biografía",
  "account_edit.bio_modal.add_title": "Añadir biografía",
  "account_edit.bio_modal.edit_title": "Editar biografía",
  "account_edit.column_button": "Listo",
  "account_edit.column_title": "Editar perfil",
  "account_edit.custom_fields.add_label": "Añadir campo",
  "account_edit.custom_fields.edit_label": "Editar campo",
  "account_edit.custom_fields.placeholder": "Añade tus pronombres, enlaces externos o cualquier otra cosa que quieras compartir.",
  "account_edit.custom_fields.reorder_button": "Reordenar campos",
  "account_edit.custom_fields.tip_content": "Puedes dar mayor credibilidad a tu cuenta de Mastodon verificando enlaces a los sitios web que te pertenecen.",
  "account_edit.custom_fields.tip_title": "Consejo: Añade enlaces verificados",
  "account_edit.custom_fields.title": "Campos personalizados",
  "account_edit.custom_fields.verified_hint": "¿Cómo añado un enlace verificado?",
  "account_edit.display_name.add_label": "Añadir nombre para mostrar",
  "account_edit.display_name.edit_label": "Editar nombre para mostrar",
  "account_edit.display_name.placeholder": "Tu nombre para mostrar es el nombre que aparece en tu perfil y en las líneas de tiempo.",
  "account_edit.display_name.title": "Nombre para mostrar",
  "account_edit.featured_hashtags.edit_label": "Añadir etiquetas",
  "account_edit.featured_hashtags.placeholder": "Ayuda a otros a identificar tus temas favoritos y a acceder rápidamente a ellos.",
  "account_edit.featured_hashtags.title": "Etiquetas destacadas",
  "account_edit.field_actions.delete": "Eliminar campo",
  "account_edit.field_actions.edit": "Editar campo",
  "account_edit.field_delete_modal.confirm": "¿Estás seguro de que quieres borrar este campo personalizado? La acción no se puede deshacer.",
  "account_edit.field_delete_modal.delete_button": "Borrar",
  "account_edit.field_delete_modal.title": "¿Borrar campo personalizado?",
  "account_edit.field_edit_modal.add_title": "Añadir campo personalizado",
  "account_edit.field_edit_modal.discard_confirm": "Descartar",
  "account_edit.field_edit_modal.discard_message": "Tienes cambios no guardados. ¿Seguro que quieres descartarlos?",
  "account_edit.field_edit_modal.edit_title": "Editar campo personalizado",
  "account_edit.field_edit_modal.length_warning": "Se superó el límite recomendado de caracteres. Es posible que quienes usan dispositivos móviles no vean el campo completo.",
  "account_edit.field_edit_modal.link_emoji_warning": "Recomendamos no usar emojis personalizados combinados con enlaces. Los campos personalizados que contengan ambos solo se mostrarán como texto en vez de un enlace, para evitar confusiones.",
  "account_edit.field_edit_modal.name_hint": "Ej.: «Sitio web personal»",
  "account_edit.field_edit_modal.name_label": "Etiqueta",
  "account_edit.field_edit_modal.url_warning": "Para añadir un enlace, incluye {protocol} al principio.",
  "account_edit.field_edit_modal.value_hint": "Ej.: «https://example.me»",
  "account_edit.field_edit_modal.value_label": "Valor",
  "account_edit.field_reorder_modal.drag_cancel": "El arrastre se ha cancelado. El campo \"{item}\" se ha soltado.",
  "account_edit.field_reorder_modal.drag_end": "El campo \"{item}\" se ha soltado.",
  "account_edit.field_reorder_modal.drag_instructions": "Para reorganizar los campos personalizados, presiona la barra espaciadora o Enter. Mientras arrastras, usa las flechas del teclado para mover el campo hacia arriba o hacia abajo. Presiona de nuevo la barra espaciadora o Enter para soltarlo en su nueva posición, o Escape para cancelar.",
  "account_edit.field_reorder_modal.drag_move": "El campo \"{item}\" se ha movido.",
  "account_edit.field_reorder_modal.drag_over": "El campo \"{item}\" se ha movido sobre \"{over}\".",
  "account_edit.field_reorder_modal.drag_start": "Campo \"{item}\" seleccionado.",
  "account_edit.field_reorder_modal.handle_label": "Arrastra el campo \"{item}\"",
  "account_edit.field_reorder_modal.title": "Reorganizar campos",
  "account_edit.image_alt_modal.add_title": "Añadir texto alternativo",
  "account_edit.image_alt_modal.details_content": "QUÉ HACER: <ul> <li>Descríbete tal como apareces en la imagen</li> <li>Usa la tercera persona (p. ej., «Alex» en lugar de «yo»)</li> <li>Sé breve: unas pocas palabras suelen ser suficientes</li> </ul> QUÉ EVITAR: <ul> <li>Empezar con «Foto de»: es redundante para los lectores de pantalla</li> </ul> EJEMPLO: <ul> <li>«Alex con camisa verde y lentes»</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Consejos: texto alternativo para fotos de perfil",
  "account_edit.image_alt_modal.edit_title": "Editar texto alternativo",
  "account_edit.image_alt_modal.text_hint": "El texto alternativo ayuda a las personas que usan lectores de pantalla a comprender tu contenido.",
  "account_edit.image_alt_modal.text_label": "Texto alternativo",
  "account_edit.image_delete_modal.confirm": "¿Seguro que quieres eliminar esta imagen? Esta acción no se puede deshacer.",
  "account_edit.image_delete_modal.delete_button": "Eliminar",
  "account_edit.image_delete_modal.title": "¿Eliminar imagen?",
  "account_edit.image_edit.add_button": "Añadir imagen",
  "account_edit.image_edit.alt_add_button": "Añadir texto alternativo",
  "account_edit.image_edit.alt_edit_button": "Editar texto alternativo",
  "account_edit.image_edit.remove_button": "Quitar imagen",
  "account_edit.image_edit.replace_button": "Sustituir imagen",
  "account_edit.item_list.delete": "Eliminar {name}",
  "account_edit.item_list.edit": "Editar {name}",
  "account_edit.name_modal.add_title": "Añadir nombre para mostrar",
  "account_edit.name_modal.edit_title": "Editar nombre para mostrar",
  "account_edit.profile_tab.button_label": "Personalizar",
  "account_edit.profile_tab.hint.description": "Estos ajustes personalizan lo que se muestra en {server} dentro de las aplicaciones oficiales, pero pueden no aplicarse en otros servidores ni en aplicaciones de terceros.",
  "account_edit.profile_tab.hint.title": "La disposición puede variar",
  "account_edit.profile_tab.show_featured.description": "«Destacado» es una pestaña opcional donde puedes mostrar otras cuentas.",
  "account_edit.profile_tab.show_featured.title": "Mostrar pestaña «Destacado»",
  "account_edit.profile_tab.show_media.description": "«Multimedia» es una pestaña opcional que muestra tus publicaciones que contienen imágenes o videos.",
  "account_edit.profile_tab.show_media.title": "Mostrar pestaña «Multimedia»",
  "account_edit.profile_tab.show_media_replies.description": "Cuando está activada, la pestaña «Multimedia» muestra tanto tus publicaciones como tus respuestas a las publicaciones de otras personas.",
  "account_edit.profile_tab.show_media_replies.title": "Incluir respuestas en la pestaña «Multimedia»",
  "account_edit.profile_tab.show_relations.description": "Muestra en tu perfil, para otras personas, las cuentas que sigues y las que te siguen. Aun así, cada persona podrá ver si la sigues.",
  "account_edit.profile_tab.show_relations.title": "Mostrar «Seguidores» y «Siguiendo»",
  "account_edit.profile_tab.subtitle": "Personaliza cómo se muestra tu perfil.",
  "account_edit.profile_tab.title": "Configuración de visualización del perfil",
  "account_edit.save": "Guardar",
  "account_edit.upload_modal.back": "Atrás",
  "account_edit.upload_modal.done": "Listo",
  "account_edit.upload_modal.next": "Siguiente",
  "account_edit.upload_modal.step_crop.zoom": "Zoom",
  "account_edit.upload_modal.step_upload.button": "Explorar archivos",
  "account_edit.upload_modal.step_upload.dragging": "Suelta el archivo para subirlo",
  "account_edit.upload_modal.step_upload.header": "Elige una imagen",
  "account_edit.upload_modal.step_upload.hint": "Formato WEBP, PNG, GIF o JPG, hasta {limit} MB.{br}La imagen se ajustará a {width}x{height} px.",
  "account_edit.upload_modal.title_add.avatar": "Añadir foto de perfil",
  "account_edit.upload_modal.title_add.header": "Añadir foto de portada",
  "account_edit.upload_modal.title_replace.avatar": "Sustituir foto de perfil",
  "account_edit.upload_modal.title_replace.header": "Sustituir foto de portada",
  "account_edit.verified_modal.details": "Añade credibilidad a tu perfil de Mastodon verificando enlaces a tus sitios web personales. Así funciona:",
  "account_edit.verified_modal.invisible_link.details": "Añade el enlace al encabezado. La parte importante es rel=\"me\", que ayuda a evitar la suplantación de identidad en sitios web con contenido generado por usuarios. También puedes usar una etiqueta de enlace en el encabezado de la página en lugar de {tag}, pero el HTML debe ser accesible sin ejecutar JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "¿Cómo hago invisible el enlace?",
  "account_edit.verified_modal.step1.header": "Copia el código HTML siguiente y pégalo en el encabezado de tu sitio web",
  "account_edit.verified_modal.step2.details": "Si ya añadiste tu sitio web como campo personalizado, tendrás que eliminarlo y volver a añadirlo para activar la verificación.",
  "account_edit.verified_modal.step2.header": "Añade tu sitio web como campo personalizado",
  "account_edit.verified_modal.title": "Cómo añadir un enlace verificado",
  "account_edit_tags.add_tag": "Añadir #{tagName}",
  "account_edit_tags.column_title": "Editar etiquetas",
  "account_edit_tags.help_text": "Las etiquetas destacadas ayudan a otras personas a descubrir tu perfil e interactuar con él. Aparecen como filtros en la vista Actividad de tu página de perfil.",
  "account_edit_tags.max_tags_reached": "Has alcanzado el número máximo de etiquetas destacadas.",
  "account_edit_tags.search_placeholder": "Introduce una etiqueta…",
  "account_edit_tags.suggestions": "Sugerencias:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# publicación} other {# publicaciones}}",
  "account_list.hidden_notice": "Esto solo es visible para ti. Para mostrar esta lista a otros, ve a <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# cuenta} other {# cuentas}}",
  "admin.dashboard.daily_retention": "Tasa de retención por usuario y por día tras su registro",
  "admin.dashboard.monthly_retention": "Tasa de retención por usuario y por mes tras su registro",
  "admin.dashboard.retention.average": "Promedio",
  "admin.dashboard.retention.cohort": "Mes de registro",
  "admin.dashboard.retention.cohort_size": "Usuarios nuevos",
  "admin.impact_report.instance_accounts": "Perfiles que esta acción borraría",
  "admin.impact_report.instance_followers": "Seguidores que nuestros usuarios perderían",
  "admin.impact_report.instance_follows": "Seguidores que sus usuarios perderían",
  "admin.impact_report.title": "Resumen de impacto",
  "alert.need_reload.message": "Mastodon se ha actualizado. Algunas funciones podrían no trabajar correctamente hasta que recargues la página.",
  "alert.rate_limited.message": "Por favor, reintenta después de {retry_time, time, medium}.",
  "alert.rate_limited.title": "Límite de la tasa de publicaciones",
  "alert.unexpected.message": "Ocurrió un error inesperado",
  "alert.unexpected.title": "¡Ocurrió un error!",
  "alt_text_badge.title": "Texto alternativo",
  "alt_text_modal.add_alt_text": "Añadir texto alternativo",
  "alt_text_modal.add_text_from_image": "Añadir el texto de la imagen",
  "alt_text_modal.cancel": "Cancelar",
  "alt_text_modal.change_thumbnail": "Cambiar miniatura",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Describe esto para personas con discapacidad auditiva…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Describe esto para personas con discapacidad visual…",
  "alt_text_modal.done": "Listo",
  "announcement.announcement": "Anuncio",
  "annual_report.announcement.action_build": "Preparar mi Wrapstodon",
  "annual_report.announcement.action_dismiss": "No, gracias",
  "annual_report.announcement.action_view": "Ver mi Wrapstodon",
  "annual_report.announcement.description": "Descubre más sobre tu participación en Mastodon durante el último año.",
  "annual_report.announcement.title": "Wrapstodon {year} ha llegado",
  "annual_report.nav_item.badge": "Nuevo",
  "annual_report.shared_page.donate": "Donar",
  "annual_report.shared_page.footer": "Generado con {heart} por el equipo de Mastodon",
  "annual_report.shared_page.footer_server_info": "{username} usa {domain}, una de las muchas comunidades que funcionan con Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} estuvo al acecho de publicaciones para Retootear y amplificó las voces de otras personas con gran puntería.",
  "annual_report.summary.archetype.booster.desc_self": "Estuviste al acecho de publicaciones para Retootear y amplificaste las voces de otras personas con gran puntería.",
  "annual_report.summary.archetype.booster.name": "El Arquero",
  "annual_report.summary.archetype.die_drei_fragezeichen": "¿¿¿???",
  "annual_report.summary.archetype.lurker.desc_public": "Sabemos que {name} estaba por ahí, en algún lugar, disfrutando de Mastodon a su manera y en silencio.",
  "annual_report.summary.archetype.lurker.desc_self": "Sabemos que estabas por ahí, en algún lugar, disfrutando de Mastodon a tu manera y en silencio.",
  "annual_report.summary.archetype.lurker.name": "El Estoico",
  "annual_report.summary.archetype.oracle.desc_public": "{name} creó más publicaciones nuevas que respuestas, manteniendo Mastodon lleno de novedades y mirando al futuro.",
  "annual_report.summary.archetype.oracle.desc_self": "Creaste más publicaciones nuevas que respuestas, manteniendo Mastodon lleno de novedades y mirando al futuro.",
  "annual_report.summary.archetype.oracle.name": "El Oráculo",
  "annual_report.summary.archetype.pollster.desc_public": "{name} creó más encuestas que otros tipos de publicaciones y mantuvo viva la curiosidad en Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Creaste más encuestas que otros tipos de publicaciones y mantuviste viva la curiosidad en Mastodon.",
  "annual_report.summary.archetype.pollster.name": "El Curioso",
  "annual_report.summary.archetype.replier.desc_public": "{name} respondió con frecuencia a publicaciones de otras personas, haciendo florecer nuevas conversaciones en Mastodon.",
  "annual_report.summary.archetype.replier.desc_self": "Respondiste con frecuencia a publicaciones de otras personas, haciendo florecer nuevas conversaciones en Mastodon.",
  "annual_report.summary.archetype.replier.name": "La Mariposa",
  "annual_report.summary.archetype.reveal": "Mostrar mi arquetipo",
  "annual_report.summary.archetype.reveal_description": "¡Gracias por formar parte de Mastodon! Es hora de descubrir qué arquetipo representaste en {year}.",
  "annual_report.summary.archetype.title_public": "El arquetipo de {name}",
  "annual_report.summary.archetype.title_self": "Tu arquetipo",
  "annual_report.summary.close": "Cerrar",
  "annual_report.summary.copy_link": "Copiar enlace",
  "annual_report.summary.followers.new_followers": "{count, plural, one {nuevo seguidor} other {nuevos seguidores}}",
  "annual_report.summary.highlighted_post.boost_count": "Esta publicación recibió {count, plural, one {un Retoot} other {# Retoots}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Esta publicación fue marcada como favorita {count, plural,one {una vez} other {# veces}}.",
  "annual_report.summary.highlighted_post.reply_count": "Esta publicación recibió {count, plural,one {una respuesta} other {# respuestas}}.",
  "annual_report.summary.highlighted_post.title": "Publicación más popular",
  "annual_report.summary.most_used_app.most_used_app": "aplicación más usada",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "etiqueta más usada",
  "annual_report.summary.most_used_hashtag.used_count": "Incluiste esta etiqueta en {count, plural,one {una publicación} other {# publicaciones}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} incluyó esta etiqueta en {count, plural, one {una publicación} other {# publicaciones}}.",
  "annual_report.summary.new_posts.new_posts": "nuevas publicaciones",
  "annual_report.summary.percentile.text": "<topLabel>Eso te coloca entre el</topLabel><percentage></percentage><bottomLabel>de quienes usan {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "No se lo diremos a Bernie.",
  "annual_report.summary.share_elsewhere": "Compartir en otro lugar",
  "annual_report.summary.share_message": "¡Obtuve el arquetipo {archetype}!",
  "annual_report.summary.share_on_mastodon": "Compartir en Mastodon",
  "attachments_list.unprocessed": "(sin procesar)",
  "audio.hide": "Ocultar audio",
  "block_modal.no_collections": "Ninguna de las dos cuentas podrá añadir a la otra a colecciones. Si ya aparecen en colecciones de la otra cuenta, se eliminarán automáticamente.",
  "block_modal.remote_users_caveat": "Le pediremos al servidor {domain} que respete tu decisión. Sin embargo, no podemos garantizar que lo haga, ya que algunos servidores pueden gestionar los bloqueos de manera diferente. Las publicaciones públicas podrían seguir siendo visibles para quienes no hayan iniciado sesión.",
  "block_modal.show_less": "Mostrar menos",
  "block_modal.show_more": "Mostrar más",
  "block_modal.they_cant_mention": "No podrán mencionarse, seguirse ni citarse mutuamente.",
  "block_modal.they_cant_see_posts": "La otra cuenta no podrá ver tu contenido y tú no podrás ver el suyo.",
  "block_modal.they_will_know": "Pueden ver que están bloqueados.",
  "block_modal.title": "¿Bloquear al usuario?",
  "block_modal.you_wont_see_mentions": "No verás publicaciones de otras personas que mencionen a esta cuenta.",
  "boost_modal.combo": "Puedes presionar {combo} para no ver este aviso la próxima vez",
  "boost_modal.reblog": "¿Retootear la publicación?",
  "boost_modal.undo_reblog": "¿Deshacer el retoot de la publicación?",
  "bundle_column_error.copy_stacktrace": "Copiar reporte de error",
  "bundle_column_error.error.body": "La página solicitada no pudo ser desplegada. Podría deberse a un error en nuestro código o a una incompatibilidad del navegador.",
  "bundle_column_error.error.title": "¡Oh no!",
  "bundle_column_error.network.body": "Se ha presentado un error al intentar cargar esta página. Podría deberse a una falla temporal de tu conexión a internet.",
  "bundle_column_error.network.title": "Error de red",
  "bundle_column_error.retry": "Inténtalo de nuevo",
  "bundle_column_error.return": "Volver al inicio",
  "bundle_column_error.routing.body": "No se pudo encontrar la página solicitada. ¿Estás seguro de que es correcta la dirección (URL) introducida en la barra de direcciones?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Cerrar",
  "bundle_modal_error.message": "Algo salió mal al cargar esta pantalla.",
  "bundle_modal_error.retry": "Inténtalo de nuevo",
  "callout.dismiss": "Descartar",
  "carousel.current": "<sr>Diapositiva</sr> {current, number} / {max, number}",
  "carousel.slide": "Diapositiva {current, number} de {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} caracteres recomendados",
  "character_counter.required": "{currentLength}/{maxLength} caracteres",
  "closed_registrations.other_server_instructions": "Puesto que Mastodon es una red descentralizada, puedes crear una cuenta en otra instancia y aún así interactuar con ésta.",
  "closed_registrations_modal.description": "Actualmente, no es posible crear una cuenta en {domain}. No obstante, ten presente que no es necesario tener una cuenta específiccamente en {domain} para usar Mastodon.",
  "closed_registrations_modal.find_another_server": "Encontrar otra instancia",
  "closed_registrations_modal.preamble": "Mastodon es una red social descentralizada, de manera que sin importar dónde crees tu cuenta, podrás interactuar con cualquiera que forme parte de este servidor.",
  "closed_registrations_modal.title": "Registrarse en Mastodon",
  "collection.share_modal.share_link_label": "Compartir enlace",
  "collection.share_modal.share_via_post": "Publicar en Mastodon",
  "collection.share_modal.share_via_system": "Compartir con…",
  "collection.share_modal.title": "Compartir la colección",
  "collection.share_modal.title_new": "¡Comparte tu nueva colección!",
  "collection.share_template_other": "Mira esta colección:",
  "collection.share_template_own": "Mira mi nueva colección:",
  "collections.account_count": "{count, plural, one {# cuenta} other {# cuentas}}",
  "collections.accounts.empty_description": "Añade hasta {count} cuentas",
  "collections.accounts.empty_editor_title": "No hay nadie en esta colección todavía",
  "collections.accounts.empty_title": "Esta colección está vacía",
  "collections.add_to_collection": "Añadir {name} a colecciones",
  "collections.block_collection_owner": "Bloquear cuenta",
  "collections.by_account": "de {account_handle}",
  "collections.collection_description": "Descripción",
  "collections.collection_language": "Idioma",
  "collections.collection_language_none": "Ninguno",
  "collections.collection_name": "Nombre",
  "collections.collection_topic": "Tema",
  "collections.confirm_account_removal": "¿Seguro que quieres quitar esta cuenta de la colección?",
  "collections.content_warning": "Advertencia de contenido",
  "collections.continue": "Continuar",
  "collections.copy_link": "Copiar enlace",
  "collections.copy_link_confirmation": "Enlace a la colección copiado al portapapeles",
  "collections.create.accounts_title": "¿A quién vas a destacar en esta colección?",
  "collections.create.basic_details_title": "Datos básicos",
  "collections.create.steps": "Paso {step}/{total}",
  "collections.create_collection": "Crear colección",
  "collections.create_new_collection": "Crear una colección nueva",
  "collections.delete_collection": "Eliminar colección",
  "collections.description_length_hint": "Límite de 100 caracteres",
  "collections.detail.author_added_you_on_date": "{author} te agregó el {date}",
  "collections.detail.loading": "Cargando colección…",
  "collections.detail.revoke_inclusion": "Quitarme",
  "collections.detail.sensitive_content": "Contenido sensible",
  "collections.detail.sensitive_note": "La descripción y las cuentas pueden no ser adecuadas para todas las personas.",
  "collections.detail.share": "Compartir esta colección",
  "collections.detail.you_are_in_this_collection": "Apareces en esta colección",
  "collections.edit_details": "Editar detalles",
  "collections.error_loading_collections": "Se ha producido un error al intentar cargar estas colecciones.",
  "collections.hidden_accounts_description": "Has bloqueado o silenciado {count, plural, one {a esta cuenta} other {a estas cuentas}}",
  "collections.hidden_accounts_link": "{count, plural, one {# cuenta oculta} other {# cuentas ocultas}}",
  "collections.hints.accounts_counter": "{count}/{max} cuentas",
  "collections.last_updated_at": "Última actualización: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Colección} other {# Colecciones}}",
  "collections.list.created_by_author": "Creada por {name}",
  "collections.list.created_by_you": "Creada por ti",
  "collections.list.featuring_you": "Apareces en ellas",
  "collections.manage_accounts": "Administrar cuentas",
  "collections.mark_as_sensitive": "Marcar como sensible",
  "collections.mark_as_sensitive_hint": "Oculta la descripción y las cuentas de la colección detrás de una advertencia de contenido. El nombre de la colección seguirá visible.",
  "collections.maximum_collection_count_description": "Tu servidor permite crear hasta {count} colecciones.",
  "collections.maximum_collection_count_reached": "Has creado el número máximo de colecciones",
  "collections.name_length_hint": "Límite de 40 caracteres",
  "collections.new_collection": "Nueva colección",
  "collections.pending_accounts.message": "Las cuentas pueden aparecer como pendientes mientras esperamos una respuesta del usuario o de su servidor. Solo tú puedes ver las cuentas pendientes.",
  "collections.pending_accounts.title": "¿Por qué aparecen cuentas pendientes?",
  "collections.remove_account": "Eliminar",
  "collections.report_collection": "Reportar esta colección",
  "collections.revoke_collection_inclusion": "Quitarme de esta colección",
  "collections.revoke_inclusion.confirmation": "Ya no apareces en «{collection}»",
  "collections.revoke_inclusion.error": "Se produjo un error. Inténtalo de nuevo más tarde.",
  "collections.search_accounts_label": "Buscar una cuenta para añadir",
  "collections.search_accounts_max_reached": "Has añadido el número máximo de cuentas",
  "collections.sensitive": "Sensible",
  "collections.share_short": "Compartir",
  "collections.sort_alphabetical": "Alfabéticamente",
  "collections.sort_by": "Ordenar por:",
  "collections.sort_date_added": "Fecha de inclusión",
  "collections.sort_last_active": "Última actividad",
  "collections.sort_most_followers": "Más seguidores",
  "collections.suggestions.can_not_add": "No se puede añadir",
  "collections.suggestions.can_not_add_desc": "Estas cuentas pueden haber desactivado su aparición en las funciones de descubrimiento o estar en un servidor que no admite colecciones.",
  "collections.suggestions.must_follow": "Primero debes seguir esta cuenta",
  "collections.suggestions.must_follow_desc": "Estas cuentas revisan todas las solicitudes de seguimiento. Los seguidores pueden añadirlas a colecciones.",
  "collections.topic_hint": "Añade una etiqueta que ayude a otras personas a comprender el tema principal de esta colección.",
  "collections.topic_special_chars_hint": "Los caracteres especiales se eliminarán al guardar.",
  "collections.unlisted_collections_description": "No aparecen en tu perfil para otras personas. Cualquiera que tenga el enlace puede encontrarlas.",
  "collections.unlisted_collections_with_count": "Colecciones no listadas ({count})",
  "collections.view_collection": "Ver colección",
  "collections.visibility_public": "Pública",
  "collections.visibility_public_hint": "Puede aparecer en resultados de búsqueda y en otros espacios donde se muestran recomendaciones.",
  "collections.visibility_title": "Visibilidad",
  "collections.visibility_unlisted": "No listada",
  "collections.visibility_unlisted_hint": "Visible para cualquiera que tenga el enlace. No aparece en resultados de búsqueda ni en recomendaciones.",
  "column.about": "Acerca de",
  "column.blocks": "Usuarios bloqueados",
  "column.bookmarks": "Marcadores",
  "column.community": "Línea de tiempo local",
  "column.create_list": "Crear lista",
  "column.direct": "Mensajes directos",
  "column.directory": "Navegar por los perfiles",
  "column.domain_blocks": "Dominios ocultados",
  "column.edit_list": "Editar lista",
  "column.favourites": "Favoritos",
  "column.firehose": "Fuentes en vivo",
  "column.firehose_local": "Línea de tiempo en vivo de este servidor",
  "column.firehose_singular": "Línea de tiempo en vivo",
  "column.follow_requests": "Solicitudes de seguimiento",
  "column.home": "Inicio",
  "column.list_members": "Administrar miembros de la lista",
  "column.lists": "Listas",
  "column.mutes": "Usuarios silenciados",
  "column.notifications": "Notificaciones",
  "column.other_collections": "Colecciones de {name}",
  "column.pins": "Toot fijado",
  "column.public": "Historia federada",
  "column.your_collections": "Tus Colecciones",
  "column_back_button.label": "Atrás",
  "column_header.hide_settings": "Ocultar ajustes",
  "column_header.moveLeft_settings": "Mover columna a la izquierda",
  "column_header.moveRight_settings": "Mover columna a la derecha",
  "column_header.pin": "Fijar",
  "column_header.show_settings": "Mostrar ajustes",
  "column_header.unpin": "Dejar de fijar",
  "column_search.cancel": "Cancelar",
  "combobox.close_results": "Cerrar resultados",
  "combobox.loading": "Cargando",
  "combobox.no_results_found": "No hay resultados para esta búsqueda",
  "combobox.open_results": "Abrir resultados",
  "combobox.results_available": "{count, plural, one {# sugerencia disponible} other {# sugerencias disponibles}}. Usa las flechas hacia arriba y hacia abajo para navegar. Presiona Enter para seleccionar.",
  "community.column_settings.local_only": "Local solamente",
  "community.column_settings.media_only": "Multimedia solamente",
  "community.column_settings.remote_only": "Remota solamente",
  "compose.error.blank_post": "La publicación no puede estar vacía.",
  "compose.language.change": "Cambiar idioma",
  "compose.language.search": "Buscar idiomas",
  "compose.published.body": "Toot publicado.",
  "compose.published.open": "Abrir",
  "compose.saved.body": "Publicación guardada.",
  "compose_form.direct_message_warning_learn_more": "Sepa más",
  "compose_form.encryption_warning": "En Mastodon, los toots no usan encriptación de punto a punto. No compartas información sensible por este medio.",
  "compose_form.hashtag_warning": "Este toot no se enlistará bajo ninguna etiqueta (hashtag). Sólo los toots públicos pueden buscarse mediante etiquetas.",
  "compose_form.lock_disclaimer": "Tu cuenta no está {locked}. Cualquier persona puede seguirte para ver tus publicaciones exclusivas para seguidores.",
  "compose_form.lock_disclaimer.lock": "bloqueado",
  "compose_form.placeholder": "¿En qué estás pensando?",
  "compose_form.poll.duration": "Duración de la encuesta",
  "compose_form.poll.multiple": "Selección múltiple",
  "compose_form.poll.option_placeholder": "Opción {number}",
  "compose_form.poll.single": "Opción única",
  "compose_form.poll.switch_to_multiple": "Cambiar la encuesta para permitir la elección de múltiples opciones",
  "compose_form.poll.switch_to_single": "Cambiar la encuesta para permitir únicamente la elección de una opción",
  "compose_form.poll.type": "Estilo",
  "compose_form.publish": "Tootear",
  "compose_form.reply": "Responder",
  "compose_form.save_changes": "Actualizar",
  "compose_form.spoiler.marked": "El contenido se ha ocultado",
  "compose_form.spoiler.unmarked": "El contenido no ha sido ocultado",
  "compose_form.spoiler_placeholder": "Advertencia de contenido (opcional)",
  "confirmation_modal.cancel": "Cancelar",
  "confirmations.block.confirm": "Bloquear",
  "confirmations.delete.confirm": "Eliminar",
  "confirmations.delete.message": "¿Estás seguro de que quieres borrar este toot?",
  "confirmations.delete.title": "¿Eliminar la publicación?",
  "confirmations.delete_collection.confirm": "Eliminar",
  "confirmations.delete_collection.message": "Esta acción no se puede deshacer.",
  "confirmations.delete_collection.title": "¿Eliminar «{name}»?",
  "confirmations.delete_list.confirm": "Borrar",
  "confirmations.delete_list.message": "¿Estás seguro de que quieres borrar esta lista permanentemente?",
  "confirmations.delete_list.title": "¿Eliminar la lista?",
  "confirmations.discard_draft.confirm": "Descartar y continuar",
  "confirmations.discard_draft.edit.cancel": "Continuar la edición",
  "confirmations.discard_draft.edit.message": "Si continúas, se descartarán los cambios que hiciste en la publicación que estás editando.",
  "confirmations.discard_draft.edit.title": "¿Descartar los cambios de tu publicación?",
  "confirmations.discard_draft.post.cancel": "Retomar el borrador",
  "confirmations.discard_draft.post.message": "Si continúas, se descartará la publicación que estás redactando.",
  "confirmations.discard_draft.post.title": "¿Descartar tu borrador?",
  "confirmations.discard_edit_media.confirm": "Descartar",
  "confirmations.discard_edit_media.message": "Tiene cambios que no han sido guardados en la descripción de la multimedia o en la previsualización. ¿Descartarlos de cualquier forma?",
  "confirmations.follow_to_list.confirm": "Seguir y añadir a la lista",
  "confirmations.follow_to_list.message": "Necesitas seguir a {name} para añadir esta cuenta a una lista.",
  "confirmations.follow_to_list.title": "¿Seguir esta cuenta?",
  "confirmations.hide_featured_tab.confirm": "Ocultar pestaña",
  "confirmations.hide_featured_tab.intro": "Puedes cambiarlo en cualquier momento en <i>Editar perfil > Configuración de pestañas del perfil</i>.",
  "confirmations.hide_featured_tab.message": "Esto ocultará la pestaña a los usuarios de {serverName} y de otros servidores que ejecuten la versión más reciente de Mastodon. En otras interfaces, la visualización puede variar.",
  "confirmations.hide_featured_tab.title": "¿Ocultar la pestaña \"Destacado\"?",
  "confirmations.logout.confirm": "Cerrar sesión",
  "confirmations.logout.message": "¿Estás seguro de que deseas cerrar la sesión?",
  "confirmations.logout.title": "¿Cerrar sesión?",
  "confirmations.missing_alt_text.confirm": "Añadir texto alternativo",
  "confirmations.missing_alt_text.message": "Tu publicación contiene contenido multimedia sin texto alternativo. Añadir descripciones permite que más personas accedan a tu contenido.",
  "confirmations.missing_alt_text.secondary": "Publicar de todos modos",
  "confirmations.missing_alt_text.title": "¿Añadir texto alternativo?",
  "confirmations.mute.confirm": "Silenciar",
  "confirmations.private_quote_notify.cancel": "Volver a editar",
  "confirmations.private_quote_notify.confirm": "Publicar",
  "confirmations.private_quote_notify.do_not_show_again": "No volver a mostrar este mensaje",
  "confirmations.private_quote_notify.message": "La persona a la que citas y las demás personas mencionadas recibirán una notificación y podrán ver tu publicación, aunque no te sigan.",
  "confirmations.private_quote_notify.title": "¿Compartir con tus seguidores y las personas mencionadas?",
  "confirmations.quiet_post_quote_info.dismiss": "No volver a recordármelo",
  "confirmations.quiet_post_quote_info.got_it": "Entendido",
  "confirmations.quiet_post_quote_info.message": "Cuando cites una publicación pública discreta, tu publicación tampoco aparecerá en las líneas de tiempo de tendencias.",
  "confirmations.quiet_post_quote_info.title": "Citar publicaciones públicas discretas",
  "confirmations.redraft.confirm": "Borrar y rehacer",
  "confirmations.redraft.message": "¿Estás seguro de que quieres borrar y rehacer este toot? Se perderán todas las respuestas, retooteos y marcas de favorito que tenga asociados.",
  "confirmations.redraft.title": "¿Eliminar y volver a redactar la publicación?",
  "confirmations.remove_from_followers.confirm": "Quitar seguidor",
  "confirmations.remove_from_followers.message": "{name} dejará de seguirte. ¿Seguro que quieres continuar?",
  "confirmations.remove_from_followers.title": "¿Quitar seguidor?",
  "confirmations.revoke_collection_inclusion.confirm": "Quitarme",
  "confirmations.revoke_collection_inclusion.message": "La persona que creó la colección no podrá volver a añadirte durante 24 horas. Para impedir que te añada a colecciones de forma permanente, puedes bloquearla.",
  "confirmations.revoke_collection_inclusion.title": "¿Quieres salir de esta colección?",
  "confirmations.revoke_quote.confirm": "Eliminar publicación",
  "confirmations.revoke_quote.message": "Esta acción no se puede deshacer.",
  "confirmations.revoke_quote.title": "¿Eliminar la publicación?",
  "confirmations.unblock.confirm": "Desbloquear",
  "confirmations.unblock.title": "¿Desbloquear a {name}?",
  "confirmations.unfollow.confirm": "Dejar de seguir",
  "confirmations.unfollow.title": "¿Dejar de seguir a {name}?",
  "confirmations.withdraw_request.confirm": "Retirar solicitud",
  "confirmations.withdraw_request.title": "¿Retirar la solicitud para seguir a {name}?",
  "content_warning.hide": "Ocultar publicación",
  "content_warning.show": "Mostrar de todos modos",
  "content_warning.show_more": "Mostrar más",
  "content_warning.show_short": "Mostrar",
  "conversation.delete": "Borrar conversación",
  "conversation.mark_as_read": "Marcar como leído",
  "conversation.open": "Ver conversación",
  "conversation.with": "Con {names}",
  "copy_icon_button.copied": "Copiado al portapapeles",
  "copy_icon_button.copy_this_text": "Copiar enlace al portapapeles",
  "copypaste.copied": "Copiado",
  "copypaste.copy_to_clipboard": "Copiar al portapapeles",
  "custom_homepage.about": "Acerca de",
  "custom_homepage.about_this_server": "Acerca de este servidor",
  "custom_homepage.administered_by": "Administrado por",
  "custom_homepage.contact": "Contacto:",
  "custom_homepage.latest_activity": "Actividad más reciente",
  "custom_homepage.these_are_the_latest_posts": "Estas son las 40 publicaciones más recientes de cuentas de este servidor.",
  "directory.federated": "Del fediverso conocido",
  "directory.local": "Únicamente de {domain}",
  "directory.new_arrivals": "Recién llegados",
  "directory.recently_active": "Recientemente activos",
  "disabled_account_banner.account_settings": "Configuración de la cuenta",
  "disabled_account_banner.text": "Actualmente, tu cuenta {disabledAccount} está deshabilitada.",
  "dismissable_banner.community_timeline": "Estas son las publicaciones más recientes de las personas cuyas cuentas se alojan en {domain}.",
  "dismissable_banner.dismiss": "Descartar",
  "dismissable_banner.public_timeline": "Estas son las publicaciones públicas más recientes de las cuentas del fediverso que siguen las personas de {domain}.",
  "domain_block_modal.block": "Bloquear servidor",
  "domain_block_modal.block_account_instead": "Bloquear @{name} en su lugar",
  "domain_block_modal.they_can_interact_with_old_posts": "Las personas de este servidor pueden seguir interactuando con tus publicaciones anteriores.",
  "domain_block_modal.they_cant_follow": "Nadie de este servidor podrá seguirte.",
  "domain_block_modal.they_wont_know": "No sabrán que han sido bloqueados.",
  "domain_block_modal.title": "¿Bloquear el dominio?",
  "domain_block_modal.you_will_lose_num_followers": "Perderás {followersCount, plural, one {{followersCountDisplay} seguidor} other {{followersCountDisplay} seguidores}} y {followingCount, plural, one {{followingCountDisplay} persona a la que sigues} other {{followingCountDisplay} personas a las que sigues}}.",
  "domain_block_modal.you_will_lose_relationships": "Perderás a todos tus seguidores y a todas las personas que sigues en este servidor.",
  "domain_block_modal.you_wont_see_posts": "No verás publicaciones ni notificaciones de usuarios de este servidor.",
  "dropdown.empty": "Selecciona una opción",
  "email_subscriptions.email": "Correo electrónico",
  "email_subscriptions.form.action": "Suscribirse",
  "email_subscriptions.form.bottom": "Recibe publicaciones en tu bandeja de entrada sin crear una cuenta de Mastodon. Puedes cancelar la suscripción en cualquier momento. Para obtener más información, consulta la <a>Política de privacidad</a>.",
  "email_subscriptions.form.title": "Suscríbete para recibir por correo las publicaciones de {name}",
  "email_subscriptions.submitted.lead": "Revisa tu bandeja de entrada y abre el correo de confirmación para terminar la suscripción.",
  "email_subscriptions.submitted.title": "Un paso más",
  "email_subscriptions.validation.email.blocked": "Proveedor de correo bloqueado",
  "email_subscriptions.validation.email.invalid": "Dirección de correo electrónico no válida",
  "embed.instructions": "Añade este toot a tu sitio web con el siguiente código.",
  "embed.preview": "Así es como se verá:",
  "emoji_button.activity": "Actividad",
  "emoji_button.clear": "Limpiar",
  "emoji_button.custom": "Personalizado",
  "emoji_button.flags": "Marcas",
  "emoji_button.food": "Comida y bebida",
  "emoji_button.label": "Insertar emoji",
  "emoji_button.nature": "Naturaleza",
  "emoji_button.not_found": "¡No hay emojis!",
  "emoji_button.objects": "Objetos",
  "emoji_button.people": "Gente",
  "emoji_button.recent": "Usados frecuentemente",
  "emoji_button.search": "Buscar…",
  "emoji_button.search_results": "Resultados de búsqueda",
  "emoji_button.symbols": "Símbolos",
  "emoji_button.travel": "Viajes y lugares",
  "empty_column.account_featured.other": "{acct} aún no ha destacado nada.",
  "empty_column.account_featured_self.no_collections_button": "Crear una colección",
  "empty_column.account_featured_self.no_collections_hide_tab": "Ocultar esta pestaña",
  "empty_column.account_featured_self.showcase_accounts": "Muestra tus cuentas favoritas",
  "empty_column.account_featured_self.showcase_accounts_desc": "Las colecciones son listas de cuentas seleccionadas para ayudar a otros a descubrir más del Fediverso.",
  "empty_column.account_featured_unknown.other": "Esta cuenta aún no ha destacado nada.",
  "empty_column.account_hides_collections": "Este usuario ha decidido no mostrar esta información",
  "empty_column.account_suspended": "Cuenta suspendida",
  "empty_column.account_timeline": "¡No hay toots aquí!",
  "empty_column.account_unavailable": "Perfil no disponible",
  "empty_column.blocks": "Tdavía no has bloqueado a ningún usuario.",
  "empty_column.bookmarked_statuses": "Todavía no has agregado ningún toot a tus marcadores. Cuando lo hagas, aparecerá aquí.",
  "empty_column.collections": "{acct} aún no ha creado ninguna colección.",
  "empty_column.collections.featured_in": "Aún no te han añadido a ninguna colección.",
  "empty_column.collections.featured_in_undiscoverable": "Para que otras personas puedan añadirte a colecciones, debes permitir que tu perfil aparezca en funciones de descubrimiento desde <link>Preferencias > Privacidad y alcance</link>.",
  "empty_column.collections_self": "Aún no has creado ninguna colección.",
  "empty_column.community": "La línea de tiempo local está vacía. ¡Escribe algo para comenzar!",
  "empty_column.direct": "Aún no tienes mensajes directos. Cuando envíes o recibas uno, aparecerá aquí.",
  "empty_column.disabled_feed": "Esta línea de tiempo ha sido deshabilitada por los administradores del servidor.",
  "empty_column.domain_blocks": "Aún no hay dominios ocultados.",
  "empty_column.explore_statuses": "Aún no se generan tendencias. ¡Vuelve más tarde!",
  "empty_column.favourited_statuses": "Todavía no has marcado ningún toot como favorito. Cuando lo hagas, aparecerá aquí.",
  "empty_column.favourites": "Nadie ha marcado este toot como favorito. Cuando suceda, aparecerá aquí.",
  "empty_column.follow_requests": "Todavía no recibes ninguna solicitud de seguimiento. Cuando la recibas, se mostrará aquí.",
  "empty_column.followed_tags": "Aún no sigues ninguna etiqueta. Cuando lo hagas, aparecerán aquí.",
  "empty_column.hashtag": "No hay nada bajo esta etiqueta",
  "empty_column.home": "Tu línea de tiempo de inicio está vacía. Sigue a más personas para llenarla.",
  "empty_column.list": "Esta lista está vacía. Cuando miembros de esta lista publiquen nuevos estatus, aparecerán aquí.",
  "empty_column.mutes": "Aún no has silenciado a ningún usuario.",
  "empty_column.notification_requests": "¡Todo en orden! No hay nada aquí. Cuando recibas nuevas notificaciones, aparecerán aquí según tu configuración.",
  "empty_column.notifications": "Aún no tienes ninguna notificación. Interactúa con otros para empezar una conversación.",
  "empty_column.public": "¡No hay nada aquí! Envía un toot público o sigue a usuarios de otras instancias para llenarlo",
  "empty_state.no_results": "Sin resultados",
  "error.no_hashtag_feed_access": "Únete o inicia sesión para ver y seguir esta etiqueta.",
  "error.unexpected_crash.explanation": "Debido a un error en nuestro código o a una incompatibilidad con el navegador web, esta página no puede mostrarse correctamente.",
  "error.unexpected_crash.explanation_addons": "Esta página no puede desplegarse correctamente. Este error a menudo se produce por una extensión del navegador o por una herramienta de traducción automática",
  "error.unexpected_crash.next_steps": "Prueba refrescando la página. Si esto no ayuda, aún podrías ser capaz de usar Mastodon a través de un navegador diferente o de una aplicación nativa.",
  "error.unexpected_crash.next_steps_addons": "Prueba deshabilitándolos. Si esto no funcionara, aún podrías ser capaz de usar Mastodon a través de un navegador diferente o de una aplicación nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar traza al portapapeles",
  "errors.unexpected_crash.report_issue": "Reportar un problema",
  "explore.suggested_follows": "Para ti",
  "explore.title": "Tendencias",
  "explore.trending_links": "Noticias",
  "explore.trending_statuses": "Publicaciones",
  "explore.trending_tags": "Etiquetas",
  "featured_carousel.current": "<sr>Publicación</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Publicación fijada} other {Publicaciones fijadas}}",
  "featured_carousel.slide": "Publicación {current, number} de {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Últimamente has publicado sobre {items}. ¿Quieres añadir estas etiquetas como destacadas?",
  "featured_tags.suggestions.add": "Añadir",
  "featured_tags.suggestions.added": "Controla tus etiquetas destacadas cuando quieras en <link>Editar perfil > Etiquetas destacadas</link>.",
  "featured_tags.suggestions.dismiss": "No, gracias",
  "filter_modal.added.context_mismatch_explanation": "Esta categoría de filtrado no es aplicable al contexto en el que has encontrado la publicación. Si quieres que sea filtrada por esta categoría, edita el filtro.",
  "filter_modal.added.context_mismatch_title": "¡Discordancia de contexto!",
  "filter_modal.added.expired_explanation": "Esta categoría de filtrado ya expiró. Para aplicarla, modifica su fecha de expiración.",
  "filter_modal.added.expired_title": "¡Filtro expirado!",
  "filter_modal.added.review_and_configure": "Para revisar y configurar esta categoría de filtrado, ve a {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Configuración de filtros",
  "filter_modal.added.settings_link": "página de configuración",
  "filter_modal.added.short_explanation": "Esta publicación ha sido añadida a la siguiente categoría de filtrado: {title}.",
  "filter_modal.added.title": "¡Filtro añadido!",
  "filter_modal.select_filter.context_mismatch": "no aplica a este contexto",
  "filter_modal.select_filter.expired": "expirado",
  "filter_modal.select_filter.prompt_new": "Nueva categoría: {name}",
  "filter_modal.select_filter.search": "Buscar o crear",
  "filter_modal.select_filter.subtitle": "Usar una categoría existente o crear una nueva",
  "filter_modal.select_filter.title": "Filtrar esta publicación",
  "filter_modal.title.status": "Filtrar una publicación",
  "filter_warning.matches_filter": "Coincide con el filtro “<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "De {count, plural, =0 {nadie} one {una persona} other {# personas}} que quizá conozcas",
  "filtered_notifications_banner.title": "Notificaciones filtradas",
  "firehose.all": "Todo",
  "firehose.local": "Este servidor",
  "firehose.remote": "Otros servidores",
  "follow_request.authorize": "Autorizar",
  "follow_request.reject": "Rechazar",
  "follow_requests.unlocked_explanation": "Aun cuando tu cuenta no está asegurada, el equipo de {domain} considera que podrías querer revisar las siguientes solicitudes manualmente.",
  "follow_suggestions.curated_suggestion": "Selección del equipo",
  "follow_suggestions.dismiss": "No volver a mostrar",
  "follow_suggestions.featured_longer": "Seleccionado por el equipo de {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popular entre las personas a las que sigues",
  "follow_suggestions.hints.featured": "Este perfil fue seleccionado por el equipo de {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Este perfil es popular entre las personas que sigues.",
  "follow_suggestions.hints.most_followed": "Este perfil es uno de los más seguidos en {domain}.",
  "follow_suggestions.hints.most_interactions": "Este perfil ha recibido mucha atención recientemente en {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Este perfil es similar a los perfiles que has seguido recientemente.",
  "follow_suggestions.personalized_suggestion": "Sugerencia personalizada",
  "follow_suggestions.popular_suggestion": "Sugerencia popular",
  "follow_suggestions.popular_suggestion_longer": "Popular en {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Similar a perfiles que has seguido recientemente",
  "follow_suggestions.view_all": "Ver todo",
  "follow_suggestions.who_to_follow": "A quién seguir",
  "followed_tags": "Etiquetas seguidas",
  "followers.hide_other_followers": "Este usuario ha elegido no mostrar a sus demás seguidores.",
  "followers.title": "Siguiendo a {name}",
  "following.hide_other_following": "Este usuario ha elegido no mostrar al resto de las cuentas que sigue.",
  "following.title": "Seguido por {name}",
  "footer.about": "Acerca de",
  "footer.about_mastodon": "Acerca de Mastodon",
  "footer.about_server": "Acerca de {domain}",
  "footer.about_this_server": "Acerca de",
  "footer.directory": "Directorio de perfiles",
  "footer.get_app": "Aplicaciones móviles",
  "footer.keyboard_shortcuts": "Atajos del teclado",
  "footer.privacy_policy": "Términos del servicio",
  "footer.source_code": "Ver código fuente",
  "footer.status": "Estatus",
  "footer.terms_of_service": "Términos del servicio",
  "form_error.blank": "El campo no puede quedar vacío.",
  "form_field.optional": "(opcional)",
  "getting_started.heading": "Primeros pasos",
  "hashtag.admin_moderation": "Abrir interfaz de moderación para #{name}",
  "hashtag.browse": "Explorar publicaciones en #{hashtag}",
  "hashtag.browse_from_account": "Explorar publicaciones de @{name} en #{hashtag}",
  "hashtag.column_header.tag_mode.all": "y {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sin {additional}",
  "hashtag.column_settings.select.no_options_message": "No se encontraron sugerencias",
  "hashtag.column_settings.select.placeholder": "Introducir etiquetas",
  "hashtag.column_settings.tag_mode.all": "Todos estos",
  "hashtag.column_settings.tag_mode.any": "Cualquiera de estos",
  "hashtag.column_settings.tag_mode.none": "Ninguno de estos",
  "hashtag.column_settings.tag_toggle": "Incluir etiquetas adicionales para esta columna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participante} other {{counter} participantes}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} publicación} other {{counter} publicaciones}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} publicación} other {{counter} publicaciones}} hoy",
  "hashtag.feature": "Destacar en el perfil",
  "hashtag.follow": "Seguir etiqueta",
  "hashtag.mute": "Silenciar #{hashtag}",
  "hashtag.unfeature": "No destacar en el perfil",
  "hashtag.unfollow": "Dejar de seguir la etiqueta",
  "hashtags.and_other": "…y {count, plural, other {# más}}",
  "hints.profiles.followers_may_be_missing": "Puede que no se muestren todos los seguidores de este perfil.",
  "hints.profiles.follows_may_be_missing": "Puede que no se muestren todas las cuentas que sigue este perfil.",
  "hints.profiles.posts_may_be_missing": "Puede que no se muestren todas las publicaciones de este perfil.",
  "hints.profiles.see_more_followers": "Ver más seguidores en {domain}",
  "hints.profiles.see_more_follows": "Ver más perfiles seguidos en {domain}",
  "hints.profiles.see_more_posts": "Ver más publicaciones en {domain}",
  "home.column_settings.show_quotes": "Mostrar citas",
  "home.column_settings.show_reblogs": "Mostrar retoots",
  "home.column_settings.show_replies": "Mostrar respuestas",
  "home.hide_announcements": "Ocultar los anuncios",
  "home.pending_critical_update.body": "¡Por favor actualiza tu servidor Mastodon lo antes posible!",
  "home.pending_critical_update.link": "Ver actualizaciones",
  "home.pending_critical_update.title": "¡Actualización de seguridad crítica disponible!",
  "home.show_announcements": "Mostrar los anuncios",
  "ignore_notifications_modal.bots_title": "¿Ignorar notificaciones de bots?",
  "ignore_notifications_modal.disclaimer": "Mastodon no puede informar a los usuarios de que has ignorado sus notificaciones. Ignorar las notificaciones no impedirá que se envíen los mensajes.",
  "ignore_notifications_modal.filter_instead": "Filtrar en vez de ignorar",
  "ignore_notifications_modal.filter_to_act_users": "Aun así podrás aceptar, rechazar o reportar usuarios",
  "ignore_notifications_modal.filter_to_avoid_confusion": "El filtrado ayuda a evitar posibles confusiones",
  "ignore_notifications_modal.filter_to_review_separately": "Puedes revisar las notificaciones filtradas por separado",
  "ignore_notifications_modal.ignore": "Ignorar notificaciones",
  "ignore_notifications_modal.limited_accounts_title": "¿Ignorar las notificaciones de cuentas moderadas?",
  "ignore_notifications_modal.new_accounts_title": "¿Ignorar las notificaciones de cuentas nuevas?",
  "ignore_notifications_modal.not_followers_title": "¿Ignorar las notificaciones de personas que no te siguen?",
  "ignore_notifications_modal.not_following_title": "¿Ignorar las notificaciones de personas a las que no sigues?",
  "ignore_notifications_modal.private_mentions_title": "¿Ignorar las notificaciones de menciones privadas no solicitadas?",
  "info_button.label": "Ayuda",
  "info_button.what_is_alt_text": "<h1>¿Qué es el texto alternativo?</h1> <p>El texto alternativo describe las imágenes para personas con discapacidad visual, conexiones de poco ancho de banda o quienes necesitan más contexto.</p> <p>Puedes mejorar la accesibilidad y la comprensión para todas las personas mediante un texto alternativo claro, conciso y objetivo.</p> <ul><li>Describe los elementos importantes.</li><li>Transcribe o resume el texto de la imagen.</li><li>Usa oraciones naturales.</li><li>Evita la información redundante.</li><li>En elementos visuales complejos, como diagramas o mapas, destaca las tendencias y conclusiones principales.</li></ul>",
  "interaction_modal.action": "Para interactuar con la publicación de {name}, debes iniciar sesión en tu cuenta del servidor de Mastodon que utilices.",
  "interaction_modal.action_follow": "Para seguir a {name}, debes iniciar sesión en tu cuenta del servidor de Mastodon que utilices.",
  "interaction_modal.go": "Ir",
  "interaction_modal.no_account_yet": "¿Aún no tienes cuenta?",
  "interaction_modal.on_another_server": "En un servidor diferente",
  "interaction_modal.on_this_server": "En este servidor",
  "interaction_modal.title": "Inicia sesión para continuar",
  "interaction_modal.username_prompt": "Por ejemplo: {example}",
  "intervals.full.days": "{number, plural, one {# día} other {# días}}",
  "intervals.full.hours": "{number, plural, one {# hora} other {# horas}}",
  "intervals.full.minutes": "{number, plural, one {# minuto} other {# minutos}}",
  "keyboard_shortcuts.back": "Retroceder",
  "keyboard_shortcuts.blocked": "Abrir la lista de usuarios bloqueados",
  "keyboard_shortcuts.boost": "Retootear",
  "keyboard_shortcuts.column": "Enfocar un toot en una de las columnas",
  "keyboard_shortcuts.compose": "Situarse en el campo para redactar el toot",
  "keyboard_shortcuts.description": "Descripción",
  "keyboard_shortcuts.direct": "Abrir la columna de menciones privadas",
  "keyboard_shortcuts.down": "Desplazarse hacia abajo en la columna",
  "keyboard_shortcuts.enter": "Abrir toot",
  "keyboard_shortcuts.explore": "Abrir la línea de tiempo de tendencias",
  "keyboard_shortcuts.favourite": "Añadir a los favoritos",
  "keyboard_shortcuts.favourites": "Abrir la lista de los favoritos",
  "keyboard_shortcuts.federated": "Abrir la línea de tiempo federada",
  "keyboard_shortcuts.heading": "Atajos del teclado",
  "keyboard_shortcuts.home": "Abrir la columna Inicio",
  "keyboard_shortcuts.hotkey": "Tecla caliente",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Retroceso",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Av Pág",
  "keyboard_shortcuts.keys.page_up": "Re Pág",
  "keyboard_shortcuts.legend": "Mostrar esta leyenda",
  "keyboard_shortcuts.load_more": "Poner el foco en el botón \"Cargar más\"",
  "keyboard_shortcuts.local": "Abrir la línea de tiempo local",
  "keyboard_shortcuts.mention": "Mencionar al autor",
  "keyboard_shortcuts.muted": "Abrir lista de usuarios silenciados",
  "keyboard_shortcuts.my_profile": "Abrir tu perfil",
  "keyboard_shortcuts.notifications": "Abrir la columna de notificaciones",
  "keyboard_shortcuts.open_media": "Para abrir la multimedia",
  "keyboard_shortcuts.pinned": "Abrir la lista de los toots fijados",
  "keyboard_shortcuts.profile": "Abrir el perfil del autor",
  "keyboard_shortcuts.quote": "Citar publicación",
  "keyboard_shortcuts.reply": "Responder",
  "keyboard_shortcuts.requests": "Abrir la lista de solicitudes de seguimiento",
  "keyboard_shortcuts.search": "Situarse en el campo de búsqueda",
  "keyboard_shortcuts.spoilers": "Para mostrar u ocultar el campo de contenido sensible",
  "keyboard_shortcuts.start": "Abrir la columna Primeros pasos",
  "keyboard_shortcuts.toggle_hidden": "Para mostrar u ocultar el texto marcado como sensible",
  "keyboard_shortcuts.toggle_sensitivity": "Para mostrar u ocultar la multimedia",
  "keyboard_shortcuts.toot": "Redactar un nuevo toot",
  "keyboard_shortcuts.top": "Mover al principio de la lista",
  "keyboard_shortcuts.translate": "Traducir una publicación",
  "keyboard_shortcuts.unfocus": "Retirar el foco del campo de redacción o búsqueda",
  "keyboard_shortcuts.up": "Desplazarse hacia arriba en la columna",
  "learn_more_link.got_it": "Entendido",
  "learn_more_link.learn_more": "Más información",
  "lightbox.close": "Cerrar",
  "lightbox.next": "Siguiente",
  "lightbox.previous": "Anterior",
  "lightbox.zoom_in": "Ampliar a tamaño real",
  "lightbox.zoom_out": "Ajustar a la ventana",
  "limited_account_hint.action": "Mostrar el perfil de cualquier modo",
  "limited_account_hint.title": "Este perfil o servidor ha sido ocultado por la moderación de {domain}.",
  "link_preview.author": "Por {name}",
  "link_preview.more_from_author": "Más de {name}",
  "link_preview.shares": "{count, plural, one {{counter} publicación} other {{counter} publicaciones}}",
  "lists.add_member": "Añadir",
  "lists.add_to_list": "Añadir a la lista",
  "lists.add_to_lists": "Incluir a {name} en las listas",
  "lists.create": "Crear",
  "lists.create_a_list_to_organize": "Crea una lista para organizar tu Inicio",
  "lists.create_list": "Crear lista",
  "lists.delete": "Borrar lista",
  "lists.done": "Listo",
  "lists.edit": "Editar lista",
  "lists.exclusive": "Ocultar miembros en Inicio",
  "lists.exclusive_hint": "Si alguien está en esta lista, ocúltalo de Inicio para no ver sus publicaciones dos veces.",
  "lists.find_users_to_add": "Buscar usuarios para añadir",
  "lists.list_members_count": "{count, plural, one {# miembro} other {# miembros}}",
  "lists.list_name": "Nombre de la lista",
  "lists.new_list_name": "Nombre de la nueva lista",
  "lists.no_lists_yet": "Aún no hay listas.",
  "lists.no_members_yet": "Aún no hay integrantes.",
  "lists.no_results_found": "No se encontraron resultados.",
  "lists.remove_member": "Quitar",
  "lists.replies_policy.followed": "Cualquier usuario a quien siga",
  "lists.replies_policy.list": "Miembros de la lista",
  "lists.replies_policy.none": "Ninguno",
  "lists.save": "Guardar",
  "lists.search": "Buscar",
  "lists.show_replies_to": "Incluir respuestas de miembros de la lista dirigidas a",
  "load_pending": "{count, plural, one {# elemento nuevo} other {# elementos nuevos}}",
  "loading_indicator.label": "Cargando...",
  "media_gallery.hide": "Ocultar",
  "moved_to_account_banner.text": "Actualmente, tu cuenta {disabledAccount} está deshabilitada porque te has mudado a {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ocultar de las notificaciones",
  "mute_modal.hide_options": "Ocultar opciones",
  "mute_modal.indefinite": "Hasta que deje de silenciar esta cuenta",
  "mute_modal.show_options": "Mostrar opciones",
  "mute_modal.they_can_mention_and_follow": "Pueden mencionarte y seguirte, pero no verás nada de ellos.",
  "mute_modal.they_wont_know": "No sabrán que han sido silenciados.",
  "mute_modal.title": "¿Silenciar al usuario?",
  "mute_modal.you_wont_see_mentions": "No verás publicaciones que mencionen a esta persona.",
  "mute_modal.you_wont_see_posts": "Podrán seguir viendo tus publicaciones, pero tú no verás las suyas.",
  "navigation_bar.about": "Acerca de",
  "navigation_bar.account_settings": "Contraseña y seguridad",
  "navigation_bar.administration": "Administración",
  "navigation_bar.advanced_interface": "Abrir en interfaz web avanzada",
  "navigation_bar.automated_deletion": "Eliminación automática de publicaciones",
  "navigation_bar.blocks": "Usuarios bloqueados",
  "navigation_bar.bookmarks": "Marcadores",
  "navigation_bar.collections": "Colecciones",
  "navigation_bar.direct": "Mensajes directos",
  "navigation_bar.domain_blocks": "Dominios ocultados",
  "navigation_bar.favourites": "Favoritos",
  "navigation_bar.filters": "Palabras filtradas",
  "navigation_bar.follow_requests": "Solicitudes para seguirte",
  "navigation_bar.followed_tags": "Etiquetas seguidas",
  "navigation_bar.follows_and_followers": "Seguidos y seguidores",
  "navigation_bar.import_export": "Importación y exportación",
  "navigation_bar.lists": "Listas",
  "navigation_bar.live_feed_local": "Actividad en vivo (local)",
  "navigation_bar.live_feed_public": "Actividad en vivo (pública)",
  "navigation_bar.logout": "Cerrar sesión",
  "navigation_bar.main": "Principal",
  "navigation_bar.moderation": "Moderación",
  "navigation_bar.more": "Más",
  "navigation_bar.mutes": "Usuarios silenciados",
  "navigation_bar.opened_in_classic_interface": "Publicaciones, cuentas y otras páginas específicas se abren por defecto en la interfaz web clásica.",
  "navigation_bar.preferences": "Preferencias",
  "navigation_bar.privacy_and_reach": "Privacidad y alcance",
  "navigation_bar.search": "Buscar",
  "navigation_bar.search_trends": "Búsqueda y tendencias",
  "navigation_panel.collapse_followed_tags": "Contraer el menú de etiquetas seguidas",
  "navigation_panel.collapse_lists": "Contraer el menú de listas",
  "navigation_panel.expand_followed_tags": "Expandir el menú de etiquetas seguidas",
  "navigation_panel.expand_lists": "Expandir el menú de listas",
  "not_signed_in_indicator.not_signed_in": "Necesitas iniciar sesión para usar este recurso.",
  "notification.added_to_collection": "{name} te añadió a una colección",
  "notification.admin.report": "{name} reportó a {target}",
  "notification.admin.report_account": "{name} reportó {count, plural, one {una publicación} other {# publicaciones}} de {target} por {category}",
  "notification.admin.report_account_other": "{name} reportó {count, plural, one {una publicación} other {# publicaciones}} de {target}",
  "notification.admin.report_statuses": "{name} reportó a {target} por {category}",
  "notification.admin.report_statuses_other": "{name} reportó a {target}",
  "notification.admin.sign_up": "{name} se registró",
  "notification.admin.sign_up.name_and_others": "{name} y {count, plural, one {# persona más} other {# personas más}} se registraron",
  "notification.annual_report.message": "¡Tu #Wrapstodon {year} te espera! Descubre los momentos más destacados y memorables de tu año en Mastodon.",
  "notification.annual_report.view": "Ver #Wrapstodon",
  "notification.collection_update": "{name} editó una colección en la que apareces",
  "notification.favourite": "{name} marcó tu toot como favorito",
  "notification.favourite.name_and_others_with_link": "{name} y <a>{count, plural, one {# persona más} other {# personas más}}</a> marcaron tu publicación como favorita",
  "notification.favourite_pm": "{name} marcó tu mención privada como favorita",
  "notification.favourite_pm.name_and_others_with_link": "{name} y <a>{count, plural, one {# persona más} other {# personas más}}</a> marcaron tu mención privada como favorita",
  "notification.follow": "{name} te empezó a seguir",
  "notification.follow.name_and_others": "{name} y <a>{count, plural, one {# persona más} other {# personas más}}</a> empezaron a seguirte",
  "notification.follow_request": "{name} te hizo una solicitud de seguimiento",
  "notification.follow_request.name_and_others": "{name} y {count, plural, one {# persona más} other {# personas más}} solicitaron seguirte",
  "notification.label.mention": "Mención",
  "notification.label.private_mention": "Mención privada",
  "notification.label.private_reply": "Respuesta privada",
  "notification.label.quote": "{name} citó tu publicación",
  "notification.label.reply": "Respuesta",
  "notification.mention": "Mención",
  "notification.mentioned_you": "{name} te mencionó",
  "notification.moderation-warning.learn_more": "Más información",
  "notification.moderation_warning": "Has recibido una advertencia de moderación",
  "notification.moderation_warning.action_delete_statuses": "Se han eliminado algunas de tus publicaciones.",
  "notification.moderation_warning.action_disable": "Tu cuenta ha sido desactivada.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Se han marcado como sensibles algunas de tus publicaciones.",
  "notification.moderation_warning.action_none": "Tu cuenta ha recibido una advertencia de moderación.",
  "notification.moderation_warning.action_sensitive": "De ahora en adelante, todas tus publicaciones se marcarán como sensibles.",
  "notification.moderation_warning.action_silence": "Tu cuenta ha sido limitada.",
  "notification.moderation_warning.action_suspend": "Tu cuenta ha sido suspendida.",
  "notification.own_poll": "Tu encuesta finalizó",
  "notification.poll": "Finalizó una encuesta en la que participaste",
  "notification.quoted_update": "{name} editó una publicación que citaste",
  "notification.reblog": "{name} ha retooteado tu publicación",
  "notification.reblog.name_and_others_with_link": "{name} y <a>{count, plural, one {# persona más} other {# personas más}}</a> retootearon tu publicación",
  "notification.relationships_severance_event": "Conexiones perdidas con {name}",
  "notification.relationships_severance_event.account_suspension": "Un administrador de {from} ha suspendido a {target}, por lo que ya no puedes recibir actualizaciones de esa cuenta ni interactuar con ella.",
  "notification.relationships_severance_event.domain_block": "Un administrador de {from} ha bloqueado {target}, lo que incluye a {followersCount} de tus seguidores y {followingCount, plural, one {# cuenta que sigues} other {# cuentas que sigues}}.",
  "notification.relationships_severance_event.learn_more": "Más información",
  "notification.relationships_severance_event.user_domain_block": "Has bloqueado {target}, eliminando {followersCount} de tus seguidores y {followingCount, plural, one {# cuenta que sigues} other {# cuentas que sigues}}.",
  "notification.status": "{name} recién publicada",
  "notification.update": "{name} editó un toot",
  "notification_requests.accept": "Aceptar",
  "notification_requests.accept_multiple": "{count, plural, one {Aceptar # solicitud…} other {Aceptar # solicitudes…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Aceptar solicitud} other {Aceptar solicitudes}}",
  "notification_requests.confirm_accept_multiple.message": "Estás a punto de aceptar {count, plural, one {una solicitud de notificación} other {# solicitudes de notificación}}. ¿Quieres continuar?",
  "notification_requests.confirm_accept_multiple.title": "¿Aceptar solicitudes de notificación?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Descartar solicitud} other {Descartar solicitudes}}",
  "notification_requests.confirm_dismiss_multiple.message": "Estás a punto de descartar {count, plural, one {una solicitud de notificación} other {# solicitudes de notificación}}. Después no podrás volver a acceder fácilmente a {count, plural, one {ella} other {ellas}}. ¿Quieres continuar?",
  "notification_requests.confirm_dismiss_multiple.title": "¿Descartar solicitudes de notificación?",
  "notification_requests.dismiss": "Descartar",
  "notification_requests.dismiss_multiple": "{count, plural, one {Descartar # solicitud…} other {Descartar # solicitudes…}}",
  "notification_requests.edit_selection": "Editar",
  "notification_requests.exit_selection": "Listo",
  "notification_requests.explainer_for_limited_account": "Las notificaciones de esta cuenta se han filtrado porque un moderador ha limitado la cuenta.",
  "notification_requests.explainer_for_limited_remote_account": "Las notificaciones de esta cuenta se han filtrado porque un moderador ha limitado la cuenta o su servidor.",
  "notification_requests.maximize": "Maximizar",
  "notification_requests.minimize_banner": "Minimizar el aviso de notificaciones filtradas",
  "notification_requests.notifications_from": "Notificaciones de {name}",
  "notification_requests.title": "Notificaciones filtradas",
  "notification_requests.view": "Ver notificaciones",
  "notifications.clear": "Limpiar notificaciones",
  "notifications.clear_confirmation": "¿Seguro que quieres limpiar permanentemente todas tus notificaciones?",
  "notifications.clear_title": "¿Borrar las notificaciones?",
  "notifications.column_settings.admin.report": "Reportes nuevos:",
  "notifications.column_settings.admin.sign_up": "Registros nuevos:",
  "notifications.column_settings.alert": "Notificaciones de escritorio",
  "notifications.column_settings.collections": "Colecciones:",
  "notifications.column_settings.favourite": "Favoritos:",
  "notifications.column_settings.filter_bar.advanced": "Mostrar todas las categorías",
  "notifications.column_settings.filter_bar.category": "Barra de filtrado rápido",
  "notifications.column_settings.follow": "Nuevos seguidores:",
  "notifications.column_settings.follow_request": "Nuevas solicitudes de seguimiento:",
  "notifications.column_settings.group": "Agrupar",
  "notifications.column_settings.mention": "Menciones:",
  "notifications.column_settings.poll": "Resultados de la encuesta:",
  "notifications.column_settings.push": "Notificaciones push",
  "notifications.column_settings.quote": "Citas:",
  "notifications.column_settings.reblog": "Retoots:",
  "notifications.column_settings.show": "Mostrar en columna",
  "notifications.column_settings.sound": "Reproducir sonido",
  "notifications.column_settings.status": "Nuevos toots:",
  "notifications.column_settings.unread_notifications.category": "Notificaciones sin leer",
  "notifications.column_settings.unread_notifications.highlight": "Resaltar notificaciones sin leer",
  "notifications.column_settings.update": "Ediciones:",
  "notifications.filter.all": "Todo",
  "notifications.filter.boosts": "Retoots",
  "notifications.filter.collections": "Colecciones",
  "notifications.filter.favourites": "Favoritos",
  "notifications.filter.follows": "Sigues",
  "notifications.filter.mentions": "Menciones",
  "notifications.filter.polls": "Resultados de la encuesta",
  "notifications.filter.statuses": "Actualizaciones de la gente a la que sigues",
  "notifications.grant_permission": "Conceder permiso",
  "notifications.group": "{count} notificaciones",
  "notifications.mark_as_read": "Marcar cada notificación como leída",
  "notifications.permission_denied": "Las notificaciones de Escritorio no están disponibles debido a que se denegó el permiso para activarlas cuando el navegador lo solicitó",
  "notifications.permission_denied_alert": "No es posible habilitar las notificaciones de Escritorio, ello porque previamente el permiso para activarlas le fue denegado al navegador",
  "notifications.permission_required": "Las notificaciones de Escritorio no están habilitadas debido a que no se le concedieron los permisos necesarios al navegador.",
  "notifications.policy.accept": "Aceptar",
  "notifications.policy.accept_hint": "Mostrar en notificaciones",
  "notifications.policy.drop": "Ignorar",
  "notifications.policy.drop_hint": "Enviar al vacío; no volverán a mostrarse",
  "notifications.policy.filter": "Filtrar",
  "notifications.policy.filter_bots_hint": "Cuentas etiquetadas como automatizadas",
  "notifications.policy.filter_bots_title": "Bots",
  "notifications.policy.filter_hint": "Enviar a la bandeja de entrada de notificaciones filtradas",
  "notifications.policy.filter_limited_accounts_hint": "Limitadas por los moderadores del servidor",
  "notifications.policy.filter_limited_accounts_title": "Cuentas moderadas",
  "notifications.policy.filter_new_accounts.hint": "Creadas durante {days, plural, one {el último día} other {los últimos # días}}",
  "notifications.policy.filter_new_accounts_title": "Cuentas nuevas",
  "notifications.policy.filter_not_followers_hint": "Incluye a personas que te siguen desde hace menos de {days, plural, one {un día} other {# días}}",
  "notifications.policy.filter_not_followers_title": "Personas que no te siguen",
  "notifications.policy.filter_not_following_hint": "Hasta que las apruebes manualmente",
  "notifications.policy.filter_not_following_title": "Personas que no sigues",
  "notifications.policy.filter_private_mentions_hint": "Se filtran salvo que respondan a una mención tuya o que sigas al remitente",
  "notifications.policy.filter_private_mentions_title": "Menciones privadas no solicitadas",
  "notifications.policy.title": "Gestionar notificaciones de…",
  "notifications_permission_banner.enable": "Habilitar las notificaciones de Escritorio",
  "notifications_permission_banner.how_to_control": "Para recibir notificaciones cuando la ventana de Mastodon no se encuentra en primer plano, necesitas habilitar las notificaciones de Escritorio. Puedes controlar cuáles eventos desplegarán las notificaciones usando el botón de arriba {icon} una vez que estén habilitadas.",
  "notifications_permission_banner.title": "Nunca perderme de nada",
  "onboarding.follows.back": "Volver",
  "onboarding.follows.empty": "Desafortunadamente, no podemos mostrar resultados ahora. Intenta usando el campo de búsqueda o explorando las líneas de tiempo. También puedes volver a intentarlo más tarde.",
  "onboarding.follows.next": "Siguiente: configura tu perfil",
  "onboarding.follows.search": "Buscar",
  "onboarding.follows.title": "Sigue a otras personas para comenzar",
  "onboarding.profile.discoverable": "Hacer que mi perfil sea visible en búsquedas y recomendaciones",
  "onboarding.profile.discoverable_hint": "Cuando habilitas que tu perfil pueda descubrirse en Mastodon, tus publicaciones pueden aparecer en resultados de búsqueda y tendencias, y tu perfil puede recomendarse a personas con intereses similares a los tuyos.",
  "onboarding.profile.display_name": "Nombre",
  "onboarding.profile.display_name_hint": "Tu nombre completo o tu apodo…",
  "onboarding.profile.finish": "Terminar",
  "onboarding.profile.note": "Biografía",
  "onboarding.profile.note_hint": "Puedes @mencionar a otras personas o #etiquetas…",
  "onboarding.profile.title": "Configuración del perfil",
  "onboarding.profile.upload_avatar": "Subir imagen de perfil",
  "onboarding.profile.upload_header": "Subir imagen de cabecera",
  "password_confirmation.exceeds_maxlength": "La contraseña en el campo de confirmación excede el límite de caracteres permitido",
  "password_confirmation.mismatching": "La contraseña en el campo de confirmación no es coincidente",
  "picture_in_picture.restore": "Restaurar",
  "poll.closed": "Cerrada",
  "poll.refresh": "Actualizar",
  "poll.reveal": "Ver resultados",
  "poll.total_people": "{count, plural, one {# persona} other {# personas}}",
  "poll.total_votes": "{count, plural, one {# voto} other {# votos}}",
  "poll.vote": "Voto",
  "poll.voted": "Votaste por esta respuesta",
  "poll.votes": "{votes, plural, one {# voto} other {# votos}}",
  "poll_button.add_poll": "Crear una encuesta",
  "poll_button.remove_poll": "Eliminar encuesta",
  "privacy.change": "Ajustar privacidad",
  "privacy.direct.long": "Todas las personas mencionadas en la publicación",
  "privacy.direct.short": "Mención privada",
  "privacy.private.long": "Sólo mostrar a tus seguidores",
  "privacy.private.short": "Seguidores",
  "privacy.public.long": "Cualquiera, dentro y fuera de Mastodon",
  "privacy.public.short": "Público",
  "privacy.quote.anyone": "{visibility}, se permiten citas",
  "privacy.quote.disabled": "{visibility}, citas deshabilitadas",
  "privacy.quote.limited": "{visibility}, citas limitadas",
  "privacy.unlisted.additional": "Se comporta exactamente como la visibilidad pública, salvo que la publicación no aparecerá en las líneas de tiempo en vivo, las etiquetas, Explorar ni la búsqueda de Mastodon, incluso si habilitaste que tu cuenta pueda descubrirse.",
  "privacy.unlisted.long": "No aparece en los resultados de búsqueda de Mastodon, las tendencias ni las líneas de tiempo públicas",
  "privacy.unlisted.short": "Pública discreta",
  "privacy_policy.last_updated": "Última actualización {date}",
  "privacy_policy.title": "Términos del servicio",
  "quote_error.edit": "No se pueden añadir citas al editar una publicación.",
  "quote_error.poll": "No se permite citar junto con una encuesta.",
  "quote_error.private_mentions": "No se permite citar junto con menciones privadas.",
  "quote_error.quote": "Solo se permite una cita a la vez.",
  "quote_error.unauthorized": "No tienes permiso para citar esta publicación.",
  "quote_error.upload": "No se permite citar junto con archivos multimedia adjuntos.",
  "recommended": "Recomendado",
  "refresh": "Actualizar",
  "regeneration_indicator.please_stand_by": "Espera, por favor.",
  "regeneration_indicator.preparing_your_home_feed": "Preparando tu Inicio…",
  "relative_time.days": "{number} d",
  "relative_time.full.days": "hace {number, plural, one {# día} other {# días}}",
  "relative_time.full.hours": "hace {number, plural, one {# hora} other {# horas}}",
  "relative_time.full.just_now": "justo ahora",
  "relative_time.full.minutes": "hace {number, plural, one {# minuto} other {# minutos}}",
  "relative_time.full.seconds": "hace {number, plural, one {# segundo} other {# segundos}}",
  "relative_time.hours": "{number} h",
  "relative_time.just_now": "ahora",
  "relative_time.minutes": "{number} m",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "hoy",
  "remove_quote_hint.button_label": "Entendido",
  "remove_quote_hint.message": "Puedes hacerlo desde el menú de opciones {icon}.",
  "remove_quote_hint.title": "¿Quieres eliminar tu publicación citada?",
  "reply_indicator.attachments": "{count, plural, one {# adjunto} other {# adjuntos}}",
  "reply_indicator.cancel": "Cancelar",
  "reply_indicator.poll": "Encuesta",
  "report.block": "Bloquear",
  "report.block_explanation": "No podrás ver sus publicaciones. No podrán ver tus publicaciones ni seguirte. Podrán decir que han sido bloqueados.",
  "report.categories.legal": "Legal",
  "report.categories.other": "Otro",
  "report.categories.spam": "Basura",
  "report.categories.violation": "El contenido viola una o más reglas del servidor",
  "report.category.subtitle": "Escoger la mejor coincidencia",
  "report.category.title_account": "Cuéntanos qué ocurre con este perfil",
  "report.category.title_collection": "Cuéntanos qué ocurre con esta colección",
  "report.category.title_status": "Cuéntanos qué ocurre con esta publicación",
  "report.close": "Hecho",
  "report.comment.title": "¿Hay algo más que consideres que debamos saber?",
  "report.forward": "Reenviar a {target}",
  "report.forward_hint": "La cuenta pertenece a otra instancia. ¿De todos modos, desea enviar una copia anónima del reporte?",
  "report.mute": "Silenciar",
  "report.mute_explanation": "No podrás ver sus publicaciones. Aún podrán seguirte y ver tus publicaciones. No sabrán que han sido silenciados.",
  "report.next": "Siguiente",
  "report.placeholder": "Comentarios adicionales",
  "report.reasons.dislike": "No me gusta",
  "report.reasons.dislike_description": "No es algo que quieras ver",
  "report.reasons.legal": "Es ilegal",
  "report.reasons.legal_description": "Crees que viola la ley de tu país o de algún otro",
  "report.reasons.other": "Es algo diferente",
  "report.reasons.other_description": "El asunto no coincide con las categorías",
  "report.reasons.spam": "Es basura (spam)",
  "report.reasons.spam_description": "Enlaces maliciosos, publicidad engañosa, respuestas repetitivas",
  "report.reasons.violation": "Infringe las reglas del servidor",
  "report.reasons.violation_description": "Sabes que infringe reglas específicas",
  "report.rules.subtitle": "Selecciona todas las que sean pertinentes",
  "report.rules.title": "¿Qué reglas se están infringiendo?",
  "report.statuses.subtitle": "Selecciona las que sean pertinentes",
  "report.statuses.title": "¿Hay algún toot que pueda respaldar este reporte?",
  "report.submission_error": "No se pudo enviar el reporte",
  "report.submission_error_details": "Comprueba tu conexión de red e inténtalo de nuevo más tarde.",
  "report.submit": "Remitir",
  "report.target": "Reportando a {target}",
  "report.thanks.take_action": "Aquí aparecen las opciones para controlar lo que ves en Mastodon:",
  "report.thanks.take_action_actionable": "Mientras atendemos esto, puedes aplicar alguna de estas medidas a @{name}:",
  "report.thanks.title": "¿No quieres ver esto?",
  "report.thanks.title_actionable": "Gracias por tu reporte. Lo revisaremos.",
  "report.unfollow": "Dejar de seguir a @{name}",
  "report.unfollow_explanation": "Estás siguiendo a esta cuenta. Para no ver sus toots en tu línea de inicio, deja de seguirla.",
  "report_notification.attached_statuses": "{count, plural, one {{count} toot adjunto} other {{count} toots adjuntos}}",
  "report_notification.categories.legal": "Legal",
  "report_notification.categories.legal_sentence": "contenido ilegal",
  "report_notification.categories.other": "Otro",
  "report_notification.categories.other_sentence": "otra",
  "report_notification.categories.spam": "Basura (spam)",
  "report_notification.categories.spam_sentence": "basura",
  "report_notification.categories.violation": "Infracción de regla",
  "report_notification.categories.violation_sentence": "infracción de las reglas",
  "report_notification.open": "Abrir reporte",
  "search.clear": "Limpiar búsqueda",
  "search.no_recent_searches": "No hay búsquedas recientes",
  "search.placeholder": "Buscar",
  "search.quick_action.account_search": "Perfiles coincidentes {x}",
  "search.quick_action.go_to_account": "Ir al perfil {x}",
  "search.quick_action.go_to_hashtag": "Ir a la etiqueta {x}",
  "search.quick_action.open_url": "Abril URL en Mastodon",
  "search.quick_action.status_search": "Toots coincidentes {x}",
  "search.search_or_paste": "Buscar o pegar URL",
  "search_popout.full_text_search_disabled_message": "No disponible en {domain}.",
  "search_popout.full_text_search_logged_out_message": "Disponible solo después de iniciar sesión.",
  "search_popout.language_code": "Código de idioma ISO",
  "search_popout.options": "Opciones de búsqueda",
  "search_popout.quick_actions": "Acciones rápidas",
  "search_popout.recent": "Búsquedas recientes",
  "search_popout.specific_date": "fecha específica",
  "search_popout.user": "usuario",
  "search_results.accounts": "Perfiles",
  "search_results.all": "Todo",
  "search_results.collections": "Colecciones",
  "search_results.hashtags": "Etiquetas",
  "search_results.no_results": "Sin resultados.",
  "search_results.no_search_yet": "Intenta buscar publicaciones, perfiles o etiquetas.",
  "search_results.see_all": "Ver todos",
  "search_results.statuses": "Toots",
  "search_results.title": "Buscar «{q}»",
  "server_banner.about_active_users": "Usuarios activos en la instancia en los últimos 30 días (Usuarios Activos por Mes)",
  "server_banner.active_users": "usuarios activos",
  "server_banner.administered_by": "Administrado por:",
  "server_banner.is_one_of_many": "{domain} es uno de los muchos servidores independientes de Mastodon que puedes usar para participar en el fediverso.",
  "server_banner.more_about_this_server": "Más información sobre este servidor",
  "server_banner.server_stats": "Estadísticas del servidor:",
  "sign_in_banner.create_account": "Crear cuenta",
  "sign_in_banner.follow_anyone": "Sigue a cualquier persona en el fediverso y consulta sus publicaciones en orden cronológico. Sin algoritmos, anuncios ni titulares engañosos.",
  "sign_in_banner.mastodon_is": "Mastodon es la mejor manera de mantenerte al día con lo que está ocurriendo.",
  "sign_in_banner.sign_in": "Iniciar sesión",
  "sign_in_banner.sso_redirect": "Iniciar sesión o Registrarse",
  "skip_links.hotkey": "<span>Atajo de teclado</span> {hotkey}",
  "skip_links.skip_to_content": "Saltar al contenido principal",
  "skip_links.skip_to_navigation": "Saltar a la navegación principal",
  "status.admin_account": "Abrir interfaz de moderación para @{name}",
  "status.admin_domain": "Abrir interfaz de moderación para {domain}",
  "status.admin_status": "Abrir este toot en la interfaz de moderación",
  "status.all_disabled": "Los retoots y las citas están deshabilitados",
  "status.block": "Bloquear a @{name}",
  "status.bookmark": "Marcador",
  "status.cancel_reblog_private": "Deshacer retoot",
  "status.cannot_edit": "No tienes permiso para editar esta publicación",
  "status.cannot_quote": "No tienes permiso para citar esta publicación",
  "status.cannot_reblog": "Este toot no puede retootearse",
  "status.contains_quote": "Contiene una cita",
  "status.context.loading": "Cargando más respuestas",
  "status.context.loading_error": "No se pudieron cargar las nuevas respuestas",
  "status.context.loading_success": "Nuevas respuestas cargadas",
  "status.context.more_replies_found": "Se encontraron más respuestas",
  "status.context.retry": "Reintentar",
  "status.context.show": "Mostrar",
  "status.continued_thread": "Continuación del hilo",
  "status.copy": "Copiar enlace al toot",
  "status.delete": "Borrar",
  "status.delete.success": "Publicación eliminada",
  "status.detailed_status": "Vista detallada de la conversación",
  "status.direct": "Mensaje directo a @{name}",
  "status.direct_indicator": "Mención directa",
  "status.edit": "Editar",
  "status.edited": "Última edición: {date}",
  "status.edited_x_times": "Editado {count, plural, one {{count} vez} other {{count} veces}}",
  "status.embed": "Obtener código para incrustar",
  "status.favourite": "Favorito",
  "status.favourites_count": "{count, plural,one {{counter} favorito}other {{counter} favoritos}}",
  "status.filter": "Filtrar esta publicación",
  "status.history.created": "{name} creado el {date}",
  "status.history.edited": "{name} editado el {date}",
  "status.load_more": "Cargar más",
  "status.media.open": "Clic para abrir",
  "status.media.show": "Clic para mostrar",
  "status.media_hidden": "Contenido multimedia oculto",
  "status.mention": "Mencionar @{name}",
  "status.more": "Más",
  "status.mute": "Silenciar a @{name}",
  "status.mute_conversation": "Silenciar conversación",
  "status.not_quoted": "No se te ha citado en esta publicación",
  "status.open": "Expandir toot",
  "status.pin": "Fijar sobre el perfil",
  "status.public_only": "Esta publicación es privada",
  "status.quote": "Citar",
  "status.quote.cancel": "Cancelar cita",
  "status.quote_error.blocked_account_hint.title": "Esta publicación está oculta porque bloqueaste a @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Esta publicación está oculta porque bloqueaste el dominio {domain}.",
  "status.quote_error.filtered": "Oculto debido a uno de tus filtros",
  "status.quote_error.limited_account_hint.action": "Mostrar de todos modos",
  "status.quote_error.limited_account_hint.title": "Esta cuenta ha sido ocultada por los moderadores de {domain}.",
  "status.quote_error.muted_account_hint.title": "Esta publicación está oculta porque silenciaste a @{name}.",
  "status.quote_error.not_available": "Publicación no disponible",
  "status.quote_error.pending_approval": "Publicación pendiente",
  "status.quote_error.pending_approval_popout.body": "En Mastodon puedes decidir quién puede citarte. Esta publicación está pendiente mientras obtenemos la aprobación de quien la publicó originalmente.",
  "status.quote_error.revoked": "Publicación eliminada por el autor",
  "status.quote_followers_only": "Solo los seguidores pueden citar esta publicación",
  "status.quote_manual_review": "El autor la revisará manualmente",
  "status.quote_noun": "Cita",
  "status.quote_policy_change": "Cambiar quién puede citar",
  "status.quote_post_author": "Ha citado una publicación de @{name}",
  "status.quote_private": "Las publicaciones privadas no se pueden citar",
  "status.quotes.empty": "Nadie ha citado esta publicación todavía. Cuando alguien lo haga, aparecerá aquí.",
  "status.quotes.local_other_disclaimer": "No se mostrarán las citas rechazadas por el autor.",
  "status.quotes.remote_other_disclaimer": "Aquí solo se garantiza que aparezcan las citas de {domain}. No se mostrarán las citas rechazadas por el autor.",
  "status.quotes_count": "{count, plural,one {{counter} cita} other {{counter} citas}}",
  "status.read_more": "Leer más",
  "status.reblog": "Retootear",
  "status.reblog_or_quote": "Retootear o citar",
  "status.reblog_private": "Retootear con tus seguidores",
  "status.reblogged_by": "Retooteado por {name}",
  "status.reblogs.empty": "Nadie ha retooteado este toot. Cuando alguien lo haga, se mostrará aquí.",
  "status.reblogs_count": "{count, plural, one {{counter} Retoot} other {{counter} Retoots}}",
  "status.redraft": "Borrar y rehacer",
  "status.remove_bookmark": "Eliminar marcador",
  "status.remove_favourite": "Quitar de favoritos",
  "status.remove_quote": "Eliminar",
  "status.replied_in_thread": "Respondió en el hilo",
  "status.replied_to": "Respondió a {name}",
  "status.reply": "Responder",
  "status.replyAll": "Responder al hilo",
  "status.report": "Reportar a @{name}",
  "status.request_quote": "Solicitar permiso para citar",
  "status.revoke_quote": "Retirar mi publicación de la publicación de @{name}",
  "status.sensitive_warning": "Contenido sensible",
  "status.share": "Compartir",
  "status.show_less_all": "Mostrar menos para todos",
  "status.show_more_all": "Mostrar más para todos",
  "status.show_original": "Mostrar original",
  "status.title.with_attachments": "{user} publicó {attachmentCount, plural, one {un adjunto} other {{attachmentCount} adjuntos}}",
  "status.translate": "Traducir",
  "status.translated_from_with": "Traducido del {lang} usando {provider}",
  "status.uncached_media_warning": "Vista previa no disponible",
  "status.unmute_conversation": "Dejar de silenciar conversación",
  "status.unpin": "Dejar de fijar al perfil",
  "subscribed_languages.lead": "Solo se mostrarán las publicaciones que estén en los idiomas seleccionados. Elija ninguno para verlas en todas las lenguas.",
  "subscribed_languages.save": "Guardar cambios",
  "subscribed_languages.target": "Cambiar los idiomas seleccionados para {target}",
  "tabs_bar.home": "Inicio",
  "tabs_bar.menu": "Menú",
  "tabs_bar.notifications": "Notificaciones",
  "tabs_bar.publish": "Nueva publicación",
  "tabs_bar.quick_links": "Enlaces rápidos",
  "tabs_bar.search": "Buscar",
  "tag.remove": "Eliminar",
  "terms_of_service.effective_as_of": "En vigor a partir del {date}",
  "terms_of_service.title": "Términos del servicio",
  "terms_of_service.upcoming_changes_on": "Próximos cambios el {date}",
  "time_remaining.days": "Restante: {number, plural, one {# día} other {# días}}",
  "time_remaining.hours": "Restante: {number, plural, one {# hora} other {# horas}}",
  "time_remaining.minutes": "Restante: {number, plural, one {# minuto} other {# minutos}}",
  "time_remaining.moments": "Tiempo restante",
  "time_remaining.seconds": "{number, plural, one {# segundo} other {# segundos}} restantes",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} personas}} durante {days, plural, one {el último día} other {los últimos {days} días}}",
  "trends.trending_now": "Tendencias ahora",
  "ui.beforeunload": "Tu borrador se perderá si sales de Mastodon.",
  "units.short.billion": "{count} MM",
  "units.short.million": "{count} M",
  "units.short.thousand": "{count} K",
  "upload_area.title": "Arrastra y suelta para subir",
  "upload_button.label": "Subir multimedia",
  "upload_error.limit": "Se superó el tamaño máximo del archivo que puede cargarse",
  "upload_error.poll": "El archivo subido no se admite en las encuestas",
  "upload_error.quote": "No se permite subir archivos al incluir citas.",
  "upload_form.drag_and_drop.instructions": "Para tomar un archivo multimedia, presiona la barra espaciadora o Enter. Mientras lo arrastras, usa las teclas de dirección para moverlo. Vuelve a presionar la barra espaciadora o Enter para soltarlo en su nueva posición, o presiona Escape para cancelar.",
  "upload_form.drag_and_drop.on_drag_cancel": "Se canceló el arrastre. Se soltó el archivo multimedia {item}.",
  "upload_form.drag_and_drop.on_drag_end": "Se soltó el archivo multimedia {item}.",
  "upload_form.drag_and_drop.on_drag_over": "Se movió el archivo multimedia {item}.",
  "upload_form.drag_and_drop.on_drag_start": "Se tomó el archivo multimedia {item}.",
  "upload_form.edit": "Editar",
  "upload_progress.label": "Subiendo…",
  "upload_progress.processing": "Procesando…",
  "username.taken": "El nombre de usuario ya está en uso. Prueba otro",
  "video.close": "Cerrar video",
  "video.download": "Descargar archivo",
  "video.exit_fullscreen": "Salir de pantalla completa",
  "video.expand": "Expandir video",
  "video.fullscreen": "Pantalla completa",
  "video.hide": "Ocultar video",
  "video.mute": "Silenciar",
  "video.pause": "Pausar",
  "video.play": "Reproducir",
  "video.skip_backward": "Retroceder",
  "video.skip_forward": "Adelantar",
  "video.unmute": "Activar sonido",
  "video.volume_down": "Bajar el volumen",
  "video.volume_up": "Subir el volumen",
  "visibility_modal.button_title": "Establecer visibilidad",
  "visibility_modal.direct_quote_warning.text": "Si guardas la configuración actual, la cita incrustada se convertirá en un enlace.",
  "visibility_modal.direct_quote_warning.title": "No se pueden incrustar citas en menciones privadas",
  "visibility_modal.header": "Visibilidad e interacción",
  "visibility_modal.helper.direct_quoting": "Las menciones privadas publicadas en Mastodon no pueden ser citadas por otros usuarios.",
  "visibility_modal.helper.privacy_editing": "La visibilidad no puede cambiarse después de publicar.",
  "visibility_modal.helper.privacy_private_self_quote": "Las citas de tus propias publicaciones privadas no pueden hacerse públicas.",
  "visibility_modal.helper.private_quoting": "Las publicaciones de Mastodon visibles solo para seguidores no pueden ser citadas por otros usuarios.",
  "visibility_modal.helper.unlisted_quoting": "Cuando otras personas te citen, sus publicaciones tampoco aparecerán en las líneas de tiempo de tendencias.",
  "visibility_modal.instructions": "Controla quién puede interactuar con esta publicación. También puedes aplicar esta configuración a todas tus publicaciones futuras desde <link>Preferencias > Publicaciones por defecto</link>.",
  "visibility_modal.privacy_label": "Visibilidad",
  "visibility_modal.quote_followers": "Solo seguidores",
  "visibility_modal.quote_label": "Quién puede citar",
  "visibility_modal.quote_nobody": "Solo yo",
  "visibility_modal.quote_public": "Cualquiera",
  "visibility_modal.save": "Guardar"
}
